var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 611.9 401",
    style: {
      enableBackground: "new 0 0 611.9 401"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3D3D3;}\r\n\t.st1{fill:#DBDBDB;}\r\n\t.st2{fill:#F4F4F4;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#C7C7C7;}\r\n\t.st5{display:none;}\r\n\t.st6{display:inline;}\r\n\t.st7{fill:#263238;}\r\n\t.st8{fill:#EAEAEA;}\r\n\t.st9{fill:#FFC727;}\r\n\t.st10{opacity:0.1;}\r\n\t.st11{fill:#FFC727;stroke:#263238;stroke-width:3.5936;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#263238;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#263238;stroke-miterlimit:10;stroke-dasharray:4.0037,4.0037;}\r\n\t.st14{fill:#455A64;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "601.3,94.5 591.8,140.9 585.6,134.9 575.1,142.4 567.1,132.4 549.1,145.5 533.8,119.8 516.7,129.8  509.9,120.5 488.1,132.7 481.6,118.7 496.8,44.9 578.6,61.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "578.6,61.8 601.3,94.5 573,88.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "589.7,150.1 575.7,218.1 465.6,195.4 479.6,128 486.1,142 507.9,129.7 514.6,139.1 531.8,129.1  547.1,154.7 565.1,141.7 573.1,151.6 583.6,144.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "432.2,142.2 320.1,149.1 311.2,5.2 394.4,0 425,25.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.4,0 425,25.6 396.1,27.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363.3,96.9l-0.4-3.2c-1.1-6.7,0.7-14.3,6.6-22.1c5.3-7,8.1-12,7.8-17.7c-0.4-6.4-4.6-10.4-12.5-10.1 c-4.5,0.3-9.4,2-12.5,4.6l-3.5-7.7c4-3.2,11-5.6,17.7-6c14.4-0.8,21.4,7.7,22,17.3c0.5,8.5-3.9,14.9-9.6,22.4 c-5.2,6.8-6.9,12.5-6.1,18.8l0.3,3.3L363.3,96.9z M361.6,114.6c-0.3-4.6,2.7-8.1,7.1-8.3c4.4-0.2,7.6,2.8,7.8,7.5 c0.2,4.4-2.4,7.9-7.1,8.2C365,122.2,361.8,119,361.6,114.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,72.4l-11.3-5.1L70,70.7c-0.5,1-1.5,1.7-2.6,1.7c-0.6,0-1.2,0.1-1.8,0.2c-1.1,0.2-2.2-0.3-2.8-1.2 l-2.2-3.1l-10.1,7.2l2.2,3.1c0.6,0.9,0.7,2.1,0.2,3.1c-0.3,0.6-0.5,1.1-0.8,1.7c-0.4,1-1.3,1.8-2.4,1.9l-3.8,0.4L47.1,98l3.8-0.4 c1.1-0.1,2.2,0.4,2.8,1.4c0.2,0.3,0.3,0.5,0.5,0.8c0.2,0.2,0.4,0.5,0.6,0.7c0.7,0.9,0.9,2,0.4,3l-1.6,3.5l11.3,5.1l1.6-3.5 c0.5-1,1.5-1.7,2.6-1.7c0.6,0,1.2-0.1,1.8-0.2c1.1-0.2,2.2,0.3,2.8,1.2l2.2,3.1l10.1-7.2l-2.2-3.1c-0.6-0.9-0.7-2.1-0.2-3.1 c0.3-0.5,0.5-1.1,0.8-1.7c0.4-1,1.3-1.8,2.4-1.9l3.8-0.4l-1.2-12.3l-3.8,0.4c-1.1,0.1-2.2-0.4-2.8-1.4c-0.2-0.3-0.3-0.5-0.5-0.8 c-0.2-0.2-0.4-0.5-0.6-0.7c-0.7-0.9-0.9-2-0.4-3.1L82.9,72.4z M76.5,83.8c3.3,4.6,2.2,10.9-2.3,14.2c-4.6,3.3-10.9,2.2-14.2-2.3 c-3.3-4.6-2.2-10.9,2.3-14.2C66.9,78.2,73.2,79.2,76.5,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.8,236l-7.5,4.3l1.3,2.3c0.4,0.7,0.4,1.5-0.1,2.2c-0.2,0.4-0.5,0.7-0.6,1.1c-0.4,0.7-1.1,1.1-1.8,1.1h-2.7 v8.7h2.7c0.8,0,1.5,0.4,1.8,1.1c0.2,0.4,0.4,0.8,0.6,1.1c0.4,0.7,0.5,1.5,0.1,2.2l-1.3,2.3l7.5,4.3l1.3-2.3c0.4-0.7,1.1-1.1,1.9-1 c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.8,0,1.5,0.3,1.9,1l1.3,2.3l7.5-4.3l-1.3-2.3c-0.4-0.7-0.4-1.5,0.1-2.2 c0.2-0.4,0.5-0.7,0.6-1.1c0.4-0.7,1.1-1.1,1.8-1.1h2.7V247h-2.7c-0.8,0-1.5-0.4-1.8-1.1c-0.2-0.4-0.4-0.8-0.6-1.1 c-0.4-0.7-0.5-1.5-0.1-2.2l1.3-2.3l-7.5-4.3l-1.3,2.3c-0.4,0.7-1.1,1-1.9,1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0 c-0.8,0-1.5-0.3-1.9-1L592.8,236z M596.6,244.3c3.9,0,7.1,3.2,7.1,7.1c0,3.9-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1 C589.5,247.5,592.7,244.3,596.6,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,35.4l-6.9,5.3l1.6,2.1c0.5,0.6,0.5,1.5,0.2,2.2c-0.2,0.4-0.4,0.8-0.5,1.2c-0.3,0.7-0.9,1.3-1.7,1.4 l-2.6,0.3l1.1,8.6l2.6-0.3c0.8-0.1,1.5,0.3,2,0.9c0.2,0.4,0.5,0.7,0.8,1c0.5,0.6,0.7,1.4,0.4,2.1l-1,2.5l8,3.3l1-2.5 c0.3-0.7,1-1.2,1.8-1.2c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.6-0.1c0.8-0.1,1.5,0.1,2,0.8l1.6,2.1l6.9-5.3l-1.6-2.1 c-0.5-0.6-0.5-1.5-0.2-2.2c0.2-0.4,0.4-0.8,0.5-1.2c0.3-0.7,0.9-1.3,1.7-1.4l2.6-0.3l-1.1-8.6l-2.6,0.3c-0.8,0.1-1.5-0.3-2-0.9 c-0.2-0.4-0.5-0.7-0.8-1c-0.5-0.6-0.7-1.4-0.4-2.1l1-2.5l-8-3.3l-1,2.5c-0.3,0.7-1,1.2-1.8,1.2c-0.2,0-0.4,0-0.6,0.1 c-0.2,0-0.4,0.1-0.6,0.1c-0.8,0.1-1.6-0.1-2-0.8L105.7,35.4z M110.6,43.2c3.9-0.5,7.5,2.2,8,6.1c0.5,3.9-2.2,7.5-6.1,8 c-3.9,0.5-7.5-2.2-8-6.1C104,47.2,106.7,43.7,110.6,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.2,261c0.4-9.7,0.2-19.4-0.4-29c-1.3-19.9-4.6-39.7-9.1-59.2c-2.5-10.9-5.7-21.7-8.9-32.5 c-0.1-0.3-0.6-0.2-0.5,0.1c10.1,37.9,18.3,77,17.8,116.4c-0.2,11-1.4,21.9-2.5,32.8c0,0.3,0.5,0.4,0.5,0.1 C53.1,280.4,53.8,270.6,54.2,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.3,140.5c0,0-15.2,38.7-11.8,47.8c3.4,9.1,10.5,11,10.5,11s-9.3,13.3-2.8,25.8c6.5,12.5,21,11.9,22,26.1 C53,251.2,53.8,192,35.3,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.4,226.8c0-0.1,0-0.1,0-0.2c-2.1-26.3-6.8-52.5-14.8-77.8c0-0.1-0.1-0.1-0.1,0c3,11.3,5.7,22.7,8,34.1 c-2-2-4.6-3.2-7.3-4.1c-0.1,0-0.1,0.1,0,0.1c2.8,1.2,5.5,2.6,7.5,5c0.4,2.2,0.9,4.5,1.3,6.7c-3.4-3.8-8.1-5.7-12.9-7.5 c-0.1,0-0.1,0.1,0,0.1c4.9,2,9.8,4.6,13.2,8.8c1.2,6.4,2.2,12.9,3.1,19.3c-2.5-2.6-5.6-4.4-9.1-5.2c-0.1,0-0.2,0.1-0.1,0.2 c3.6,1,6.7,3.1,9.2,5.9c0,0,0,0,0.1,0c0.3,2.3,0.6,4.6,0.9,6.8c-1.9-1.6-4-2.9-6.4-3.8c-0.1,0-0.1,0.1,0,0.1c2.4,1,4.5,2.5,6.4,4.2 c0,0,0.1,0,0.1,0c0.3,2.2,0.5,4.3,0.7,6.5c-3.5-4.2-7.8-7.3-12.9-9.2c-0.1,0-0.2,0.1-0.1,0.2c5,2.2,9.4,5.6,12.7,9.8 c0.1,0.1,0.2,0.1,0.3,0.1c0.3,3.3,0.6,6.7,0.9,10c0,0,0.1,0.1,0.1,0C51.9,233.6,51.7,230.2,51.4,226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.1,175c-2.6-1.8-6-2.6-9.2-2.9c-0.1,0-0.1,0.1,0,0.1c3.3,0.5,6,1.7,9.1,3C39.1,175.2,39.2,175.1,39.1,175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41,215.9c-2.1-1.3-4.5-2-6.9-2.4c-0.1,0-0.1,0.1,0,0.1c2.4,0.4,4.6,1.3,6.8,2.4C41,216.2,41.1,216,41,215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.3,188.9c-6.4,4.5-12.5,9.6-17.6,15.4c-5.5,6.2-9.6,13.2-12.4,21c-5.8,16-8.9,33.2-9.2,50.2 c-0.2,9.5,0.7,18.9,2.7,28.2c0.1,0.3,0.6,0.2,0.5-0.1c-2.5-16.3-2.4-33,0.3-49.3c2.6-16,6.7-33.4,16.9-46.4 c5.5-7.1,12.4-12.7,19.3-18.4C95.1,189.2,94.6,188.7,94.3,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,264c0,0,5.2-8.8,12.9-16.4c7.6-7.6,14.1-13,15-18.1c1-5-7.6-8.8-7.6-8.8s10.6,1.9,13.4-2.5 c2.9-4.4,4.3-30.1,4.3-30.1S76.1,201.8,67.1,221C58.2,240.3,57.3,264,57.3,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.6,194.7c-8.1,7.9-16.2,16.4-21,26.8c-1.6,3.6-3,7.3-4.2,11.1c0,0,0,0,0,0c-0.2,0.8-0.5,1.5-0.7,2.3 c0,0,0,0.1,0,0.1c-2.4,7.8-4,15.8-5.5,23.7c0,0.1,0.1,0.1,0.1,0c0.8-4,1.7-8,2.8-12.1c0,0,0.1,0,0.1,0c1.6-0.7,3.3-1.1,5-1.3 c0.1,0,0.1-0.2,0-0.2c-1.7,0.1-3.4,0.4-5,0.9c0.9-3.6,1.9-7.3,3.1-10.8c3.7-0.9,7.6-1.4,11.4-1.5c0,0,0-0.1,0-0.1 c-3.8-0.2-7.5,0.2-11.2,1c0.2-0.6,0.4-1.2,0.6-1.8c2.5-0.6,5-1,7.6-1.3c0,0,0-0.1,0-0.1c-2.5,0.1-5,0.3-7.4,0.9 c1-3.1,2.2-6.1,3.4-9.1c1-2.5,2.3-4.8,3.6-7c2.1-0.5,4-0.9,6.1-1.1c0.1,0,0.1-0.1,0-0.1c-1.9-0.1-3.9,0-5.7,0.6 c1-1.6,2.1-3.2,3.2-4.8c0,0,0,0,0,0c4.3-1,8.7-1.8,13.1-1c0.1,0,0.1-0.1,0-0.1c-4.2-1.1-8.4-0.5-12.5,0.4c0.5-0.6,0.9-1.2,1.4-1.8 c2.6-0.8,5.3-1.2,8-1.3c0.1,0,0.1-0.1,0-0.1c-2.5-0.2-5.1,0-7.5,0.7c3.6-4.4,7.5-8.6,11.4-12.7C89,194.6,88.8,194.5,88.6,194.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.4,212.2c-1.3-0.1-2.5-0.3-3.8-0.1c-0.2,0-0.1,0.3,0,0.3c1.3,0,2.5-0.1,3.8,0 C88.5,212.3,88.5,212.2,88.4,212.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.6,237.1c-2,0-4,0.5-5.9,1.2c0,0,0,0.1,0,0.1c2-0.5,3.9-0.7,5.9-1C74.8,237.3,74.8,237.1,74.6,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.4,228.5c-0.8,0-1.7,0.1-2.5,0.2c-0.1,0-0.1,0.1,0,0.1c0.8,0,1.7,0,2.5-0.1 C70.6,228.7,70.6,228.5,70.4,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,216.2c6.2,2.1,12.3,4.9,17.8,8.4c5.9,3.7,10.8,8.5,14.9,14.1c8.4,11.6,14.9,24.8,19.1,38.5 c2.3,7.7,3.8,15.5,4.3,23.5c0,0.3-0.4,0.3-0.4,0c-1.8-13.8-5.7-27.3-11.6-39.9c-5.8-12.3-13.2-25.5-24.4-33.7 c-6.1-4.5-13-7.4-19.9-10.4C0.4,216.5,0.6,216,1,216.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,268.4c0,0-6.3-5.9-14.2-10.3c-7.9-4.4-14.4-7.3-16.4-11.2c-2-3.9,4.2-8.9,4.2-8.9s-8.1,4-11.5,1.1 C7.1,236.2,0,215.7,0,215.7s18.7,6.7,30.4,20.1C42.1,249.3,48.3,268.4,48.3,268.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.3,264.2c-9.4-17.6-21.8-33.5-38.9-43.9c0,0,0,0,0,0c4.5,2.9,8.7,6.2,12.5,9.8c-3.5-0.1-7,0.5-10.1,2.1 c-0.1,0,0,0.1,0.1,0.1c3.4-1.2,6.7-1.9,10.3-1.7c0.1,0,0.1,0,0.1,0c0.6,0.6,1.2,1.2,1.8,1.8c-1.8,0.1-3.6,0.3-5.4,0.7 c0,0,0,0.1,0,0.1c1.9-0.4,3.8-0.5,5.7-0.5c3.1,3.1,6.1,6.5,8.8,10c-1.2-0.2-2.6-0.1-3.8,0.3c-0.1,0-0.1,0.2,0,0.1 c1.4-0.2,2.7-0.1,4-0.1c0.5,0.7,1,1.3,1.5,2c-3.8-0.2-7.6,0.1-11.4,1.1c-0.1,0,0,0.1,0,0.1c3.9-0.8,7.7-1,11.7-0.8 c0.5,0.6,0.9,1.3,1.4,1.9c-2.3-0.1-4.5,0.2-6.8,0.8c-0.1,0-0.1,0.2,0,0.1c2.3-0.5,4.6-0.7,7-0.5c2,2.8,3.9,5.6,5.8,8.5 c-1-0.2-2-0.1-3,0.2c-0.1,0,0,0.1,0,0.1c1.1-0.1,2.1,0,3.2,0.2c1.7,2.6,3.3,5.2,4.8,7.8C47.1,264.6,47.4,264.4,47.3,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.8,249.6c-1.8-0.2-3.7,0.1-5.4,0.7c0,0,0,0.1,0,0.1c1.8-0.3,3.6-0.5,5.4-0.6 C32.9,249.8,32.9,249.6,32.8,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.4,228.2c-0.8-0.1-1.7,0-2.5,0.1c-0.1,0-0.1,0.2,0,0.1c0.8-0.1,1.6-0.1,2.5-0.1 C16.6,228.4,16.6,228.2,16.4,228.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.4,326.4 30.2,326.4 36.2,282.3 37.7,271 64.9,271 66.4,282.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "66.4,282.3 36.2,282.3 37.7,271 64.9,271  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 267.1,
    className: "st1",
    width: 34.9,
    height: 9.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,109.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.9-0.7-1.1 L458.2,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.2,0,0.2l2.2-0.8C455.5,113.2,455.1,113,454.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,108.2c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.2,0.3-0.2,0.6C446.3,107.6,446.8,108.2,447.5,108.2 z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,113.5,448.1,113,447.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.2,0.1,0.3l2.2-0.8C444.8,116.9,444.4,116.6,443.9,116.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -11.4352 71.6946)",
    className: "st1",
    cx: 440.3,
    cy: 107,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S437.4,109.4,436.7,109.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.9,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C441.5,113.5,440.9,113,440.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,117.1,437.4,116.6,436.7,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 433.1,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.5,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,104.6c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C435.7,104.2,436.2,104.6,436.7,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C434.3,113.5,433.8,113,433.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.5,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C430.7,117.1,430.2,116.6,429.5,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.3,0.1,0.4l2.2-0.8C434.1,120.5,433.6,120.2,433.1,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C423.5,102.7,423,102.2,422.3,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428.3,103.4c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.9-0.7-1.1l-0.6-0.1 C428.8,102.2,428.3,102.7,428.3,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,106.3,426.6,105.8,425.9,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 422.3,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,113.5,426.6,113,425.9,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C423.5,117.1,423,116.6,422.3,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,120.7,426.6,120.2,425.9,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,123.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0,0.3,0.1,0.5l2.2-0.8C423.3,124.1,422.9,123.7,422.3,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,101c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.2,0.3-0.2,0.5C417.5,100.5,418.1,101,418.7,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,102.7,415.8,102.2,415.1,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 418.7,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S415.8,109.4,415.1,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C419.9,113.5,419.4,113,418.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,117.1,415.8,116.6,415.1,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 418.7,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S415.8,123.7,415.1,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,99.1,412.2,98.6,411.6,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C409.2,102.7,408.6,102.2,408,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,106.3,412.2,105.8,411.6,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 408,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,113.5,412.2,113,411.6,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C409.2,117.1,408.6,116.6,408,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,120.7,412.2,120.2,411.6,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 408,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.4,0.1,0.5l2.2-0.8C412.6,127.8,412.1,127.3,411.6,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,99.1,405,98.6,404.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C402,102.7,401.4,102.2,400.8,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,97.4c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C407,97,407.4,97.4,408,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,106.3,405,105.8,404.4,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 400.8,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,113.5,405,113,404.4,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C402,117.1,401.4,116.6,400.8,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,120.7,405,120.2,404.4,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 400.8,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,127.9,405,127.3,404.4,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.4,0.2,0.6l2.2-0.7C401.9,131.4,401.4,130.9,400.8,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.6,96.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.7-1l-0.6-0.1 C400.1,95,399.6,95.6,399.6,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,99.1,397.8,98.6,397.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.6,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C394.8,102.7,394.3,102.2,393.6,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 397.2,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,113.5,397.8,113,397.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.6,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C394.8,117.1,394.3,116.6,393.6,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 397.2,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,127.9,397.8,127.3,397.2,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,93.8c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C388.8,93.3,389.3,93.8,390,93.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 386.4,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,99.1,390.7,98.6,390,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C387.6,102.7,387.1,102.2,386.4,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,106.3,390.7,105.8,390,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 386.4,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,113.5,390.7,113,390,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C387.6,117.1,387.1,116.6,386.4,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,120.7,390.7,120.2,390,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 386.4,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,127.9,390.7,127.3,390,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 386.4,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,134.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.5,0.2,0.7l2.1-0.7C391.2,135,390.7,134.5,390,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C384,92,383.5,91.4,382.8,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,95.5,379.9,95,379.2,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C384,99.1,383.5,98.6,382.8,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,102.7,379.9,102.2,379.2,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 382.8,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S379.9,109.4,379.2,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C384,113.5,383.5,113,382.8,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,117.1,379.9,116.6,379.2,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 382.8,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S379.9,123.7,379.2,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C384,127.9,383.5,127.3,382.8,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,131.5,379.9,130.9,379.2,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 382.8,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.6,0.3,0.8l2.1-0.7c0,0,0,0,0-0.1 C380.4,138.7,379.9,138.1,379.2,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C376.8,92,376.3,91.4,375.6,91.4z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 372,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,90.2c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C378.2,89.9,378.7,90.2,379.2,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,99.1,376.3,98.6,375.6,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C373.2,102.7,372.7,102.2,372,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,106.3,376.3,105.8,375.6,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 372,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C376.8,113.5,376.3,113,375.6,113z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C373.2,117.1,372.7,116.6,372,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,120.7,376.3,120.2,375.6,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 372,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,127.9,376.3,127.3,375.6,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 372,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S376.3,134.5,375.6,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C373.2,138.7,372.7,138.1,372,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 364.9,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.8,89c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.1 C371.4,87.8,370.8,88.4,370.8,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,92,369.1,91.4,368.5,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 364.9,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,99.1,369.1,98.6,368.5,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C366.1,102.7,365.5,102.2,364.9,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,106.3,369.1,105.8,368.5,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 364.9,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,113.5,369.1,113,368.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C366.1,117.1,365.5,116.6,364.9,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,120.7,369.1,120.2,368.5,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 364.9,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,127.9,369.1,127.3,368.5,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 364.9,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S369.1,134.5,368.5,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C366.1,138.7,365.5,138.1,364.9,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.6,0.3,0.8l2-0.7c0-0.1,0-0.1,0-0.2 C369.6,142.2,369.1,141.7,368.5,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,86.6c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C360.1,86.1,360.6,86.6,361.3,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S358.3,87.8,357.7,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C362.5,92,361.9,91.4,361.3,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,95.5,358.3,95,357.7,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C362.5,99.1,361.9,98.6,361.3,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,102.7,358.3,102.2,357.7,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 361.3,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S358.3,109.4,357.7,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C362.5,113.5,361.9,113,361.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,117.1,358.3,116.6,357.7,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 361.3,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S358.3,123.7,357.7,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C362.5,127.9,361.9,127.3,361.3,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,131.5,358.3,130.9,357.7,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 361.3,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,138.7,358.3,138.1,357.7,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 361.3,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.2,0.7,0.4,0.9l1.9-0.7c0-0.1,0-0.2,0-0.2 C358.9,145.8,358.3,145.3,357.7,145.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 354.1,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 350.5,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C355.3,92,354.7,91.4,354.1,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 350.5,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C355.3,99.1,354.7,98.6,354.1,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C351.7,102.7,351.2,102.2,350.5,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 354.1,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 350.5,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C355.3,113.5,354.7,113,354.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C351.7,117.1,351.2,116.6,350.5,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 354.1,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 350.5,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C355.3,127.9,354.7,127.3,354.1,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 350.5,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 354.1,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C351.7,138.7,351.2,138.1,350.5,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 354.1,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C351.7,145.8,351.2,145.3,350.5,145.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 346.9,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S344,87.8,343.3,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,83c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C349.5,82.7,349.9,83,350.5,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C348.1,92,347.6,91.4,346.9,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C344.5,95.5,344,95,343.3,95z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C348.1,99.1,347.6,98.6,346.9,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C344.5,102.7,344,102.2,343.3,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 346.9,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S344,109.4,343.3,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C348.1,113.5,347.6,113,346.9,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C344.5,117.1,344,116.6,343.3,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 346.9,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S344,123.7,343.3,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C348.1,127.9,347.6,127.3,346.9,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C344.5,131.5,344,130.9,343.3,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 346.9,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C344.5,138.7,344,138.1,343.3,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 346.9,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C344.5,145.8,344,145.3,343.3,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.2,0.7,0.5,1l1.8-0.6c0-0.1,0.1-0.2,0.1-0.3 C348.1,149.4,347.6,148.9,346.9,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C337.3,81.2,336.8,80.6,336.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,81.8c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.1 C342.6,80.7,342.1,81.2,342.1,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,84.8,340.4,84.2,339.7,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 336.1,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,92,340.4,91.4,339.7,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 336.1,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,99.1,340.4,98.6,339.7,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C337.3,102.7,336.8,102.2,336.1,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,106.3,340.4,105.8,339.7,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 336.1,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,113.5,340.4,113,339.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C337.3,117.1,336.8,116.6,336.1,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,120.7,340.4,120.2,339.7,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 336.1,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,127.9,340.4,127.3,339.7,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 336.1,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S340.4,134.5,339.7,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C337.3,138.7,336.8,138.1,336.1,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,142.2,340.4,141.7,339.7,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C337.3,145.8,336.8,145.3,336.1,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C340.9,149.4,340.4,148.9,339.7,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.3,0.8,0.6,1l1.7-0.6c0.1-0.1,0.1-0.3,0.1-0.4 C337.3,153,336.8,152.5,336.1,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,79.4c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C331.3,78.9,331.9,79.4,332.5,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C330.1,81.2,329.6,80.6,328.9,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,84.8,333.2,84.2,332.5,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 328.9,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,92,333.2,91.4,332.5,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 328.9,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,99.1,333.2,98.6,332.5,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C330.1,102.7,329.6,102.2,328.9,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,106.3,333.2,105.8,332.5,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 328.9,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,113.5,333.2,113,332.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C330.1,117.1,329.6,116.6,328.9,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,120.7,333.2,120.2,332.5,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 328.9,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,127.9,333.2,127.3,332.5,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 328.9,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S333.2,134.5,332.5,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C330.1,138.7,329.6,138.1,328.9,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,142.2,333.2,141.7,332.5,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.9,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C330.1,145.8,329.6,145.3,328.9,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C333.7,149.4,333.2,148.9,332.5,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 328.9,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325.3,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,81.2,322.4,80.6,321.8,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325.3,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S322.4,87.8,321.8,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C326.5,92,326,91.4,325.3,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C323,95.5,322.4,95,321.8,95z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C326.5,99.1,326,98.6,325.3,98.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,102.7,322.4,102.2,321.8,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325.3,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S322.4,109.4,321.8,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C326.5,113.5,326,113,325.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,117.1,322.4,116.6,321.8,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325.3,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S322.4,123.7,321.8,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C326.5,127.9,326,127.3,325.3,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,131.5,322.4,130.9,321.8,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325.3,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,138.7,322.4,138.1,321.8,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325.3,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,145.8,322.4,145.3,321.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C326.5,149.4,326,148.9,325.3,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C323,153,322.4,152.5,321.8,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.3,156.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.5,0.3,0.9,0.7,1.1l1.5-0.5c0.1-0.2,0.2-0.3,0.2-0.5 C326.5,156.6,326,156.1,325.3,156.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C315.8,81.2,315.2,80.6,314.6,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.8,75.9c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C320.8,75.5,321.2,75.9,321.8,75.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 314.6,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C319.4,92,318.8,91.4,318.2,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 314.6,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C319.4,99.1,318.8,98.6,318.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C315.8,102.7,315.2,102.2,314.6,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 314.6,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C319.4,113.5,318.8,113,318.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C315.8,117.1,315.2,116.6,314.6,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 314.6,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C319.4,127.9,318.8,127.3,318.2,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 314.6,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C315.8,138.7,315.2,138.1,314.6,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C315.8,145.8,315.2,145.3,314.6,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C319.4,149.4,318.8,148.9,318.2,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 314.6,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 318.2,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.5,0.4,1,0.8,1.1l1.3-0.5c0.1-0.2,0.2-0.4,0.2-0.7 C315.8,160.2,315.2,159.7,314.6,159.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.4,74.7c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.1 C313.9,73.5,313.4,74,313.4,74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,77.6,311.6,77.1,311,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C308.6,81.2,308,80.6,307.4,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,84.8,311.6,84.2,311,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,92,311.6,91.4,311,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,99.1,311.6,98.6,311,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C308.6,102.7,308,102.2,307.4,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,106.3,311.6,105.8,311,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,113.5,311.6,113,311,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C308.6,117.1,308,116.6,307.4,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,120.7,311.6,120.2,311,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,127.9,311.6,127.3,311,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S311.6,134.5,311,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C308.6,138.7,308,138.1,307.4,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,142.2,311.6,141.7,311,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C308.6,145.8,308,145.3,307.4,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C312.2,149.4,311.6,148.9,311,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 307.4,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S311.6,156.1,311,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C308.6,160.2,308,159.7,307.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,72.3c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C302.6,71.7,303.1,72.3,303.8,72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S300.9,73.5,300.2,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,77.6,304.5,77.1,303.8,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,81.2,300.9,80.6,300.2,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,84.8,304.5,84.2,303.8,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S300.9,87.8,300.2,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,92,304.5,91.4,303.8,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,95.5,300.9,95,300.2,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,99.1,304.5,98.6,303.8,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,102.7,300.9,102.2,300.2,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,106.3,304.5,105.8,303.8,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S300.9,109.4,300.2,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,113.5,304.5,113,303.8,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,117.1,300.9,116.6,300.2,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,120.7,304.5,120.2,303.8,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S300.9,123.7,300.2,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,127.9,304.5,127.3,303.8,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,131.5,300.9,130.9,300.2,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S304.5,134.5,303.8,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,138.7,300.9,138.1,300.2,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,142.2,304.5,141.7,303.8,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,145.8,300.9,145.3,300.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C305,149.4,304.5,148.9,303.8,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,153,300.9,152.5,300.2,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S304.5,156.1,303.8,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C301.4,160.2,300.9,159.7,300.2,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.6,0.4,1.1,1,1.2l1.1-0.4c0.2-0.2,0.3-0.5,0.3-0.8 C305,163.8,304.5,163.3,303.8,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,70.4,297.3,69.9,296.6,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C294.2,81.2,293.7,80.6,293,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,92,297.3,91.4,296.6,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,99.1,297.3,98.6,296.6,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C294.2,102.7,293.7,102.2,293,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,113.5,297.3,113,296.6,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C294.2,117.1,293.7,116.6,293,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,127.9,297.3,127.3,296.6,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C294.2,138.7,293.7,138.1,293,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C294.2,145.8,293.7,145.3,293,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,149.4,297.3,148.9,296.6,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 293,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 296.6,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C294.2,160.2,293.7,159.7,293,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C297.8,163.8,297.3,163.3,296.6,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,168c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2l0.8-0.3 C294,168.8,294.2,168.4,294.2,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C290.6,70.4,290.1,69.9,289.4,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S286.5,73.5,285.8,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,68.7c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C292,68.3,292.5,68.7,293,68.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,81.2,286.5,80.6,285.8,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S286.5,87.8,285.8,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C290.6,92,290.1,91.4,289.4,91.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C287,95.5,286.5,95,285.8,95z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C290.6,99.1,290.1,98.6,289.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,102.7,286.5,102.2,285.8,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S286.5,109.4,285.8,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C290.6,113.5,290.1,113,289.4,113z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,117.1,286.5,116.6,285.8,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S286.5,123.7,285.8,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C290.6,127.9,290.1,127.3,289.4,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,131.5,286.5,130.9,285.8,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,138.7,286.5,138.1,285.8,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,145.8,286.5,145.3,285.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C290.6,149.4,290.1,148.9,289.4,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,153,286.5,152.5,285.8,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 289.4,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C287,160.2,286.5,159.7,285.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C290.6,163.8,290.1,163.3,289.4,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.8,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S286.5,166.9,285.8,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.7,170.7l0.7-0.2c0,0,0,0,0,0C289.2,170.4,288.9,170.5,288.7,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,66.8,279.3,66.3,278.7,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.6,67.5c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.1 C285.2,66.3,284.6,66.8,284.6,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,70.4,282.9,69.9,282.2,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,81.2,279.3,80.6,278.7,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,92,282.9,91.4,282.2,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,99.1,282.9,98.6,282.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,102.7,279.3,102.2,278.7,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,113.5,282.9,113,282.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,117.1,279.3,116.6,278.7,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,127.9,282.9,127.3,282.2,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,138.7,279.3,138.1,278.7,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,145.8,279.3,145.3,278.7,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,149.4,282.9,148.9,282.2,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.2,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C279.8,160.2,279.3,159.7,278.7,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,163.8,282.9,163.3,282.2,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 278.7,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.2,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C283.4,171,282.9,170.4,282.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,65.1c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C273.9,64.5,274.4,65.1,275.1,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,66.8,272.1,66.3,271.5,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,70.4,275.7,69.9,275.1,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,77.6,275.7,77.1,275.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,81.2,272.1,80.6,271.5,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,84.8,275.7,84.2,275.1,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,92,275.7,91.4,275.1,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,99.1,275.7,98.6,275.1,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,102.7,272.1,102.2,271.5,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,106.3,275.7,105.8,275.1,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,113.5,275.7,113,275.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,117.1,272.1,116.6,271.5,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,120.7,275.7,120.2,275.1,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,127.9,275.7,127.3,275.1,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S275.7,134.5,275.1,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,138.7,272.1,138.1,271.5,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,142.2,275.7,141.7,275.1,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,145.8,272.1,145.3,271.5,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,149.4,275.7,148.9,275.1,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S275.7,156.1,275.1,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,160.2,272.1,159.7,271.5,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,163.8,275.7,163.3,275.1,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.5,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C276.3,171,275.7,170.4,275.1,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C272.7,174.6,272.1,174,271.5,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.8,174.4l1.1-0.4c-0.1,0-0.1,0-0.2,0C278.3,174,278,174.2,277.8,174.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,63.2,268.5,62.7,267.9,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,66.8,264.9,66.3,264.3,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,70.4,268.5,69.9,267.9,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S264.9,73.5,264.3,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,77.6,268.5,77.1,267.9,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,81.2,264.9,80.6,264.3,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,84.8,268.5,84.2,267.9,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S264.9,87.8,264.3,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,92,268.5,91.4,267.9,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,95.5,264.9,95,264.3,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,99.1,268.5,98.6,267.9,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,102.7,264.9,102.2,264.3,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,106.3,268.5,105.8,267.9,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S264.9,109.4,264.3,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,113.5,268.5,113,267.9,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,117.1,264.9,116.6,264.3,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,120.7,268.5,120.2,267.9,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S264.9,123.7,264.3,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,127.9,268.5,127.3,267.9,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,131.5,264.9,130.9,264.3,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S268.5,134.5,267.9,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,138.7,264.9,138.1,264.3,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,142.2,268.5,141.7,267.9,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,145.8,264.9,145.3,264.3,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,149.4,268.5,148.9,267.9,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,153,264.9,152.5,264.3,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S268.5,156.1,267.9,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,160.2,264.9,159.7,264.3,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,163.8,268.5,163.3,267.9,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S264.9,166.9,264.3,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.9,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C269.1,171,268.5,170.4,267.9,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C265.5,174.6,264.9,174,264.3,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.9,178.1l1.3-0.4c-0.1,0-0.2-0.1-0.3-0.1C267.5,177.6,267.1,177.8,266.9,178.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,66.8,257.8,66.3,257.1,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,61.5c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C263.3,61.1,263.7,61.5,264.3,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,70.4,261.4,69.9,260.7,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,81.2,257.8,80.6,257.1,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,92,261.4,91.4,260.7,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,99.1,261.4,98.6,260.7,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,102.7,257.8,102.2,257.1,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,113.5,261.4,113,260.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,117.1,257.8,116.6,257.1,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,127.9,261.4,127.3,260.7,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,138.7,257.8,138.1,257.1,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,145.8,257.8,145.3,257.1,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,149.4,261.4,148.9,260.7,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,160.2,257.8,159.7,257.1,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,163.8,261.4,163.3,260.7,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 257.1,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.7,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C261.9,171,261.4,170.4,260.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C258.3,174.6,257.8,174,257.1,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.7,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,59.6,250.6,59.1,249.9,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.9,60.3c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.1 C256.4,59.1,255.9,59.6,255.9,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,63.2,254.2,62.7,253.5,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,66.8,250.6,66.3,249.9,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,70.4,254.2,69.9,253.5,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,77.6,254.2,77.1,253.5,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,81.2,250.6,80.6,249.9,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,84.8,254.2,84.2,253.5,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,92,254.2,91.4,253.5,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,99.1,254.2,98.6,253.5,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,102.7,250.6,102.2,249.9,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,106.3,254.2,105.8,253.5,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,113.5,254.2,113,253.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,117.1,250.6,116.6,249.9,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,120.7,254.2,120.2,253.5,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,127.9,254.2,127.3,253.5,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S254.2,134.5,253.5,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,138.7,250.6,138.1,249.9,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,142.2,254.2,141.7,253.5,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,145.8,250.6,145.3,249.9,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,149.4,254.2,148.9,253.5,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S254.2,156.1,253.5,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,160.2,250.6,159.7,249.9,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,163.8,254.2,163.3,253.5,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C254.7,171,254.2,170.4,253.5,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C251.1,174.6,250.6,174,249.9,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S254.2,177.6,253.5,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.9,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.1,181.8l1.5-0.5c-0.1-0.1-0.3-0.1-0.5-0.1C256.7,181.2,256.3,181.5,256.1,181.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,57.9c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C245.1,57.4,245.7,57.9,246.3,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,59.6,243.4,59.1,242.7,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,66.8,243.4,66.3,242.7,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C247.5,70.4,247,69.9,246.3,69.9z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,81.2,243.4,80.6,242.7,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C247.5,92,247,91.4,246.3,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C247.5,99.1,247,98.6,246.3,98.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,102.7,243.4,102.2,242.7,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C247.5,113.5,247,113,246.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,117.1,243.4,116.6,242.7,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C247.5,127.9,247,127.3,246.3,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,138.7,243.4,138.1,242.7,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,145.8,243.4,145.3,242.7,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C247.5,149.4,247,148.9,246.3,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C243.9,160.2,243.4,159.7,242.7,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C247.5,163.8,247,163.3,246.3,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.3,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C247.5,171,247,170.4,246.3,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C243.9,174.6,243.4,174,242.7,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 246.3,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242.7,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.2,185.6l1.7-0.6c-0.2-0.1-0.4-0.2-0.6-0.2C245.8,184.8,245.4,185.1,245.2,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,56,239.8,55.5,239.1,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,59.6,236.2,59.1,235.6,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,63.2,239.8,62.7,239.1,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,66.8,236.2,66.3,235.6,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,70.4,239.8,69.9,239.1,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,77.6,239.8,77.1,239.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,81.2,236.2,80.6,235.6,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,84.8,239.8,84.2,239.1,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,92,239.8,91.4,239.1,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,99.1,239.8,98.6,239.1,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,102.7,236.2,102.2,235.6,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,106.3,239.8,105.8,239.1,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,113.5,239.8,113,239.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,117.1,236.2,116.6,235.6,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,120.7,239.8,120.2,239.1,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,127.9,239.8,127.3,239.1,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S239.8,134.5,239.1,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,138.7,236.2,138.1,235.6,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,142.2,239.8,141.7,239.1,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,145.8,236.2,145.3,235.6,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,149.4,239.8,148.9,239.1,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S239.8,156.1,239.1,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C236.7,160.2,236.2,159.7,235.6,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,163.8,239.8,163.3,239.1,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,171,239.8,170.4,239.1,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C236.7,174.6,236.2,174,235.6,174z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S239.8,177.6,239.1,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.6,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C240.3,185.3,239.8,184.8,239.1,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C233.2,56,232.6,55.5,232,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,59.6,229,59.1,228.4,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.6,54.3c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C234.6,53.9,235,54.3,235.6,54.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,66.8,229,66.3,228.4,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C233.2,70.4,232.6,69.9,232,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S229,73.5,228.4,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,81.2,229,80.6,228.4,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S229,87.8,228.4,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C233.2,92,232.6,91.4,232,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C229.6,95.5,229,95,228.4,95z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C233.2,99.1,232.6,98.6,232,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,102.7,229,102.2,228.4,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S229,109.4,228.4,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C233.2,113.5,232.6,113,232,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,117.1,229,116.6,228.4,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S229,123.7,228.4,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C233.2,127.9,232.6,127.3,232,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,131.5,229,130.9,228.4,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,138.7,229,138.1,228.4,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,145.8,229,145.3,228.4,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C233.2,149.4,232.6,148.9,232,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,153,229,152.5,228.4,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,160.2,229,159.7,228.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C233.2,163.8,232.6,163.3,232,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S229,166.9,228.4,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C233.2,171,232.6,170.4,232,170.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,174.6,229,174,228.4,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 232,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S229,181.2,228.4,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C233.2,185.3,232.6,184.8,232,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.4,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C229.6,188.9,229,188.4,228.4,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.4,189.2l1.8-0.6c-0.2-0.1-0.4-0.2-0.7-0.2C235,188.4,234.6,188.8,234.4,189.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.2,53.1c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.2 C227.7,51.9,227.2,52.5,227.2,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,56,225.4,55.5,224.8,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,59.6,221.8,59.1,221.2,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,66.8,221.8,66.3,221.2,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,70.4,225.4,69.9,224.8,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,81.2,221.8,80.6,221.2,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,92,225.4,91.4,224.8,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,99.1,225.4,98.6,224.8,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,102.7,221.8,102.2,221.2,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,113.5,225.4,113,224.8,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,117.1,221.8,116.6,221.2,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,127.9,225.4,127.3,224.8,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,138.7,221.8,138.1,221.2,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,145.8,221.8,145.3,221.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,149.4,225.4,148.9,224.8,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C222.4,160.2,221.8,159.7,221.2,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,163.8,225.4,163.3,224.8,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,171,225.4,170.4,224.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.2,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C222.4,174.6,221.8,174,221.2,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.8,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C226,185.3,225.4,184.8,224.8,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 221.2,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.6,192.9l1.9-0.6c-0.2-0.2-0.5-0.3-0.8-0.3C224.2,192,223.8,192.4,223.6,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,50.7c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C216.4,50.2,216.9,50.7,217.6,50.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,56,218.3,55.5,217.6,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,59.6,214.7,59.1,214,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,63.2,218.3,62.7,217.6,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,66.8,214.7,66.3,214,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,70.4,218.3,69.9,217.6,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,77.6,218.3,77.1,217.6,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,81.2,214.7,80.6,214,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,84.8,218.3,84.2,217.6,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,92,218.3,91.4,217.6,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,99.1,218.3,98.6,217.6,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,102.7,214.7,102.2,214,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,106.3,218.3,105.8,217.6,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,113.5,218.3,113,217.6,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,117.1,214.7,116.6,214,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,120.7,218.3,120.2,217.6,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,127.9,218.3,127.3,217.6,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S218.3,134.5,217.6,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,138.7,214.7,138.1,214,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,142.2,218.3,141.7,217.6,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,145.8,214.7,145.3,214,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,149.4,218.3,148.9,217.6,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S218.3,156.1,217.6,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,160.2,214.7,159.7,214,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,163.8,218.3,163.3,217.6,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,171,218.3,170.4,217.6,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C215.2,174.6,214.7,174,214,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S218.3,177.6,217.6,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C218.8,185.3,218.3,184.8,217.6,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 214,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.6,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S218.3,192,217.6,192z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,52.4,207.5,51.9,206.8,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,56,211.1,55.5,210.4,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,59.6,207.5,59.1,206.8,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,66.8,207.5,66.3,206.8,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,70.4,211.1,69.9,210.4,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S207.5,73.5,206.8,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,81.2,207.5,80.6,206.8,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S207.5,87.8,206.8,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,92,211.1,91.4,210.4,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C208,95.5,207.5,95,206.8,95z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,99.1,211.1,98.6,210.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,102.7,207.5,102.2,206.8,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S207.5,109.4,206.8,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,113.5,211.1,113,210.4,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,117.1,207.5,116.6,206.8,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S207.5,123.7,206.8,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,127.9,211.1,127.3,210.4,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,131.5,207.5,130.9,206.8,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,138.7,207.5,138.1,206.8,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,145.8,207.5,145.3,206.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,149.4,211.1,148.9,210.4,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,153,207.5,152.5,206.8,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,160.2,207.5,159.7,206.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,163.8,211.1,163.3,210.4,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S207.5,166.9,206.8,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,171,211.1,170.4,210.4,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,174.6,207.5,174,206.8,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S207.5,181.2,206.8,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.4,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C211.6,185.3,211.1,184.8,210.4,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,188.9,207.5,188.4,206.8,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 210.4,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C208,196.1,207.5,195.6,206.8,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.8,196.6l2-0.7c-0.2-0.2-0.5-0.3-0.8-0.3C213.4,195.6,212.9,196,212.8,196.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,47.1c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C205.8,46.8,206.3,47.1,206.8,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,56,203.9,55.5,203.2,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,59.6,200.3,59.1,199.6,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,66.8,200.3,66.3,199.6,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,70.4,203.9,69.9,203.2,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,81.2,200.3,80.6,199.6,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,92,203.9,91.4,203.2,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,99.1,203.9,98.6,203.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,102.7,200.3,102.2,199.6,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,113.5,203.9,113,203.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,117.1,200.3,116.6,199.6,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,127.9,203.9,127.3,203.2,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,138.7,200.3,138.1,199.6,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,145.8,200.3,145.3,199.6,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,149.4,203.9,148.9,203.2,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,160.2,200.3,159.7,199.6,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,163.8,203.9,163.3,203.2,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,171,203.9,170.4,203.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C200.8,174.6,200.3,174,199.6,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C204.4,185.3,203.9,184.8,203.2,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 199.6,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 203.2,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.6,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C200.8,196.1,200.3,195.6,199.6,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,199.2c-0.6,0-1.1,0.5-1.2,1.1l2.1-0.7C203.9,199.3,203.6,199.2,203.2,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,45.3,193.1,44.7,192.4,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,45.9c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.2 C198.9,44.8,198.4,45.3,198.4,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,48.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,48.9,196.7,48.3,196,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,56,196.7,55.5,196,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,59.6,193.1,59.1,192.4,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,63.2,196.7,62.7,196,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,66.8,193.1,66.3,192.4,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,70.4,196.7,69.9,196,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,77.6,196.7,77.1,196,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,81.2,193.1,80.6,192.4,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,84.8,196.7,84.2,196,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,92,196.7,91.4,196,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,99.1,196.7,98.6,196,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,102.7,193.1,102.2,192.4,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,106.3,196.7,105.8,196,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,113.5,196.7,113,196,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,117.1,193.1,116.6,192.4,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,120.7,196.7,120.2,196,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,127.9,196.7,127.3,196,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S196.7,134.5,196,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,138.7,193.1,138.1,192.4,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,142.2,196.7,141.7,196,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,145.8,193.1,145.3,192.4,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,149.4,196.7,148.9,196,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S196.7,156.1,196,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,160.2,193.1,159.7,192.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,163.8,196.7,163.3,196,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,171,196.7,170.4,196,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,174.6,193.1,174,192.4,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S196.7,177.6,196,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,185.3,196.7,184.8,196,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.4,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S196.7,192,196,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C193.6,196.1,193.1,195.6,192.4,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C197.2,199.7,196.7,199.2,196,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0,0,0,0,0l2.1-0.7C193.2,203,192.8,202.8,192.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,43.5c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C187.7,43,188.2,43.5,188.9,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,45.3,185.9,44.7,185.3,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C190.1,56,189.5,55.5,188.9,55.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,59.6,185.9,59.1,185.3,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,66.8,185.9,66.3,185.3,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,70.4,189.5,69.9,188.9,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,81.2,185.9,80.6,185.3,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C190.1,92,189.5,91.4,188.9,91.4z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,99.1,189.5,98.6,188.9,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,102.7,185.9,102.2,185.3,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C190.1,113.5,189.5,113,188.9,113z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,117.1,185.9,116.6,185.3,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,127.9,189.5,127.3,188.9,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,138.7,185.9,138.1,185.3,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,145.8,185.9,145.3,185.3,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,149.4,189.5,148.9,188.9,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,160.2,185.9,159.7,185.3,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,163.8,189.5,163.3,188.9,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,171,189.5,170.4,188.9,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C186.5,174.6,185.9,174,185.3,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.9,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C190.1,185.3,189.5,184.8,188.9,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.3,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,196.1,185.9,195.6,185.3,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.9,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C186.5,203.3,185.9,202.8,185.3,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,41.7,182.3,41.1,181.7,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,45.3,178.7,44.7,178.1,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,48.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,48.9,182.3,48.3,181.7,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,56,182.3,55.5,181.7,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,59.6,178.7,59.1,178.1,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,63.2,182.3,62.7,181.7,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,66.8,178.7,66.3,178.1,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,70.4,182.3,69.9,181.7,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,77.6,182.3,77.1,181.7,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,81.2,178.7,80.6,178.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,84.8,182.3,84.2,181.7,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,92,182.3,91.4,181.7,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,99.1,182.3,98.6,181.7,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,102.7,178.7,102.2,178.1,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,106.3,182.3,105.8,181.7,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,113.5,182.3,113,181.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,117.1,178.7,116.6,178.1,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,120.7,182.3,120.2,181.7,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,127.9,182.3,127.3,181.7,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S182.3,134.5,181.7,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,138.7,178.7,138.1,178.1,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,142.2,182.3,141.7,181.7,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,145.8,178.7,145.3,178.1,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,149.4,182.3,148.9,181.7,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S182.3,156.1,181.7,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,160.2,178.7,159.7,178.1,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,163.8,182.3,163.3,181.7,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,171,182.3,170.4,181.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C179.3,174.6,178.7,174,178.1,174z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S182.3,177.6,181.7,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,185.3,182.3,184.8,181.7,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.1,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S182.3,192,181.7,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,196.1,178.7,195.6,178.1,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C182.9,199.7,182.3,199.2,181.7,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C179.3,203.3,178.7,202.8,178.1,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.7,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0,0,0.1,0,0.1l2.2-0.7C182.4,206.6,182.1,206.4,181.7,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,41.7,175.1,41.1,174.5,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,45.3,171.6,44.7,170.9,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.1,39.9c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C177.1,39.6,177.5,39.9,178.1,39.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,52.4,171.6,51.9,170.9,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C175.7,56,175.1,55.5,174.5,55.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,59.6,171.6,59.1,170.9,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,66.8,171.6,66.3,170.9,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,70.4,175.1,69.9,174.5,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S171.6,73.5,170.9,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,81.2,171.6,80.6,170.9,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S171.6,87.8,170.9,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C175.7,92,175.1,91.4,174.5,91.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,95.5,171.6,95,170.9,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,99.1,175.1,98.6,174.5,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,102.7,171.6,102.2,170.9,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S171.6,109.4,170.9,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C175.7,113.5,175.1,113,174.5,113z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,117.1,171.6,116.6,170.9,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S171.6,123.7,170.9,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,127.9,175.1,127.3,174.5,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,131.5,171.6,130.9,170.9,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,138.7,171.6,138.1,170.9,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,145.8,171.6,145.3,170.9,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,149.4,175.1,148.9,174.5,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,153,171.6,152.5,170.9,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,160.2,171.6,159.7,170.9,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,163.8,175.1,163.3,174.5,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S171.6,166.9,170.9,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,171,175.1,170.4,174.5,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,174.6,171.6,174,170.9,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S171.6,181.2,170.9,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,185.3,175.1,184.8,174.5,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,188.9,171.6,188.4,170.9,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,196.1,171.6,195.6,170.9,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.5,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C172.1,203.3,171.6,202.8,170.9,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C175.7,206.9,175.1,206.4,174.5,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.9,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.1,0,0.2l2.2-0.8C171.7,210.2,171.4,210,170.9,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.7,38.7c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.2 C170.2,37.6,169.7,38.1,169.7,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,41.7,168,41.1,167.3,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,45.3,164.4,44.7,163.7,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,56,168,55.5,167.3,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,59.6,164.4,59.1,163.7,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,66.8,164.4,66.3,163.7,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,70.4,168,69.9,167.3,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,81.2,164.4,80.6,163.7,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,92,168,91.4,167.3,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,99.1,168,98.6,167.3,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,102.7,164.4,102.2,163.7,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,113.5,168,113,167.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,117.1,164.4,116.6,163.7,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,127.9,168,127.3,167.3,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,138.7,164.4,138.1,163.7,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,145.8,164.4,145.3,163.7,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,149.4,168,148.9,167.3,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,160.2,164.4,159.7,163.7,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,163.8,168,163.3,167.3,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,171,168,170.4,167.3,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C164.9,174.6,164.4,174,163.7,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,185.3,168,184.8,167.3,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,196.1,164.4,195.6,163.7,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 167.3,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C164.9,203.3,164.4,202.8,163.7,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.3,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C168.5,206.9,168,206.4,167.3,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.7,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,36.3c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C158.9,35.8,159.5,36.3,160.1,36.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,41.7,160.8,41.1,160.1,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,45.3,157.2,44.7,156.5,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,48.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,48.9,160.8,48.3,160.1,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,56,160.8,55.5,160.1,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,59.6,157.2,59.1,156.5,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,63.2,160.8,62.7,160.1,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,66.8,157.2,66.3,156.5,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,70.4,160.8,69.9,160.1,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,77.6,160.8,77.1,160.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,81.2,157.2,80.6,156.5,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,84.8,160.8,84.2,160.1,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,92,160.8,91.4,160.1,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,99.1,160.8,98.6,160.1,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,102.7,157.2,102.2,156.5,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,106.3,160.8,105.8,160.1,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,113.5,160.8,113,160.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,117.1,157.2,116.6,156.5,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,120.7,160.8,120.2,160.1,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,127.9,160.8,127.3,160.1,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S160.8,134.5,160.1,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,138.7,157.2,138.1,156.5,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,142.2,160.8,141.7,160.1,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,145.8,157.2,145.3,156.5,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,149.4,160.8,148.9,160.1,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S160.8,156.1,160.1,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,160.2,157.2,159.7,156.5,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,163.8,160.8,163.3,160.1,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,171,160.8,170.4,160.1,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,174.6,157.2,174,156.5,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S160.8,177.6,160.1,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,185.3,160.8,184.8,160.1,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S160.8,192,160.1,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,196.1,157.2,195.6,156.5,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,199.7,160.8,199.2,160.1,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C157.7,203.3,157.2,202.8,156.5,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C161.3,206.9,160.8,206.4,160.1,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.5,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.2,0.1,0.3l2.2-0.8C161,213.8,160.6,213.5,160.1,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,34.5,153.6,34,152.9,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,37.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,38.1,150,37.5,149.3,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,41.7,153.6,41.1,152.9,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,45.3,150,44.7,149.3,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,52.4,150,51.9,149.3,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,56,153.6,55.5,152.9,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,59.6,150,59.1,149.3,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,66.8,150,66.3,149.3,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,70.4,153.6,69.9,152.9,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S150,73.5,149.3,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,81.2,150,80.6,149.3,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S150,87.8,149.3,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,92,153.6,91.4,152.9,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C150.5,95.5,150,95,149.3,95z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,99.1,153.6,98.6,152.9,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,102.7,150,102.2,149.3,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S150,109.4,149.3,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,113.5,153.6,113,152.9,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,117.1,150,116.6,149.3,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S150,123.7,149.3,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,127.9,153.6,127.3,152.9,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,131.5,150,130.9,149.3,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,138.7,150,138.1,149.3,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,145.8,150,145.3,149.3,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,149.4,153.6,148.9,152.9,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,153,150,152.5,149.3,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,160.2,150,159.7,149.3,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,163.8,153.6,163.3,152.9,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S150,166.9,149.3,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,171,153.6,170.4,152.9,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,174.6,150,174,149.3,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S150,181.2,149.3,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,185.3,153.6,184.8,152.9,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,188.9,150,188.4,149.3,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,196.1,150,195.6,149.3,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,203.3,150,202.8,149.3,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.9,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C154.1,206.9,153.6,206.4,152.9,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C150.5,210.5,150,210,149.3,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.9,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.2,0.1,0.4l2.2-0.8C150.3,217.5,149.9,217.1,149.3,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,34.5,146.4,34,145.8,34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,32.8c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C148.4,32.4,148.8,32.8,149.3,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,41.7,146.4,41.1,145.8,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,45.3,142.8,44.7,142.2,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,56,146.4,55.5,145.8,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,59.6,142.8,59.1,142.2,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,66.8,142.8,66.3,142.2,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,70.4,146.4,69.9,145.8,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,81.2,142.8,80.6,142.2,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,92,146.4,91.4,145.8,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,99.1,146.4,98.6,145.8,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,102.7,142.8,102.2,142.2,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,113.5,146.4,113,145.8,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,117.1,142.8,116.6,142.2,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,127.9,146.4,127.3,145.8,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,138.7,142.8,138.1,142.2,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,145.8,142.8,145.3,142.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,149.4,146.4,148.9,145.8,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,160.2,142.8,159.7,142.2,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,163.8,146.4,163.3,145.8,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,171,146.4,170.4,145.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C143.4,174.6,142.8,174,142.2,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,185.3,146.4,184.8,145.8,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,196.1,142.8,195.6,142.2,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,203.3,142.8,202.8,142.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C146.9,206.9,146.4,206.4,145.8,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.2,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.8,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C143.4,217.7,142.8,217.1,142.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,30.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,30.4,135,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,31.6c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-0.6-0.2 C141.5,30.4,141,30.9,141,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,34.5,139.2,34,138.6,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,37.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,38.1,135.6,37.5,135,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,41.7,139.2,41.1,138.6,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,45.3,135.6,44.7,135,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,52.4,135.6,51.9,135,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,56,139.2,55.5,138.6,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,59.6,135.6,59.1,135,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,66.8,135.6,66.3,135,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,70.4,139.2,69.9,138.6,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,73.5,135,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,81.2,135.6,80.6,135,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,87.8,135,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,92,139.2,91.4,138.6,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C136.2,95.5,135.6,95,135,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,99.1,139.2,98.6,138.6,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,102.7,135.6,102.2,135,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,109.4,135,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,113.5,139.2,113,138.6,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,117.1,135.6,116.6,135,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,123.7,135,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,127.9,139.2,127.3,138.6,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,131.5,135.6,130.9,135,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,138.7,135.6,138.1,135,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,145.8,135.6,145.3,135,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,149.4,139.2,148.9,138.6,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,153,135.6,152.5,135,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,160.2,135.6,159.7,135,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,163.8,139.2,163.3,138.6,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,166.9,135,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,171,139.2,170.4,138.6,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,174.6,135.6,174,135,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S135.6,181.2,135,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,185.3,139.2,184.8,138.6,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,188.9,135.6,188.4,135,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,196.1,135.6,195.6,135,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,203.3,135.6,202.8,135,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C139.8,206.9,139.2,206.4,138.6,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,210.5,135.6,210,135,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.6,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C136.2,217.7,135.6,217.1,135,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0,0.3,0.1,0.4l2.2-0.8C139.6,221.1,139.1,220.7,138.6,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,29.2c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C130.2,28.6,130.7,29.2,131.4,29.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 31.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,34.5,132,34,131.4,34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,41.7,132,41.1,131.4,41.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C129,45.3,128.5,44.7,127.8,44.7z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,56,132,55.5,131.4,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C129,59.6,128.5,59.1,127.8,59.1z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C129,66.8,128.5,66.3,127.8,66.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,70.4,132,69.9,131.4,69.9z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C129,81.2,128.5,80.6,127.8,80.6z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,92,132,91.4,131.4,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,99.1,132,98.6,131.4,98.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,102.7,128.5,102.2,127.8,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C132.6,113.5,132,113,131.4,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,117.1,128.5,116.6,127.8,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,127.9,132,127.3,131.4,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,138.7,128.5,138.1,127.8,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,145.8,128.5,145.3,127.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,149.4,132,148.9,131.4,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,160.2,128.5,159.7,127.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,163.8,132,163.3,131.4,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,171,132,170.4,131.4,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C129,174.6,128.5,174,127.8,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,185.3,132,184.8,131.4,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,196.1,128.5,195.6,127.8,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,203.3,128.5,202.8,127.8,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,206.9,132,206.4,131.4,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.8,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 131.4,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C129,217.7,128.5,217.1,127.8,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C132.6,221.3,132,220.7,131.4,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,224.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.4,0.1,0.5l2.2-0.8C128.8,224.7,128.4,224.3,127.8,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,26.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,27.3,124.9,26.8,124.2,26.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 31.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,34.5,124.9,34,124.2,34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,41.7,124.9,41.1,124.2,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,45.3,121.3,44.7,120.6,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,48.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,48.9,124.9,48.3,124.2,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,56,124.9,55.5,124.2,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,59.6,121.3,59.1,120.6,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,63.2,124.9,62.7,124.2,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,66.8,121.3,66.3,120.6,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,70.4,124.9,69.9,124.2,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,77.6,124.9,77.1,124.2,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,81.2,121.3,80.6,120.6,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,84.8,124.9,84.2,124.2,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,92,124.9,91.4,124.2,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,99.1,124.9,98.6,124.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,102.7,121.3,102.2,120.6,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,106.3,124.9,105.8,124.2,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,113.5,124.9,113,124.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,117.1,121.3,116.6,120.6,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,120.7,124.9,120.2,124.2,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,127.9,124.9,127.3,124.2,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S124.9,134.5,124.2,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,138.7,121.3,138.1,120.6,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,142.2,124.9,141.7,124.2,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,145.8,121.3,145.3,120.6,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,149.4,124.9,148.9,124.2,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S124.9,156.1,124.2,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,160.2,121.3,159.7,120.6,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,163.8,124.9,163.3,124.2,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,171,124.9,170.4,124.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C121.8,174.6,121.3,174,120.6,174z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S124.9,177.6,124.2,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,185.3,124.9,184.8,124.2,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S124.9,192,124.2,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,196.1,121.3,195.6,120.6,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,199.7,124.9,199.2,124.2,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,203.3,121.3,202.8,120.6,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,206.9,124.9,206.4,124.2,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,214.1,124.9,213.5,124.2,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C121.8,217.7,121.3,217.1,120.6,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C125.4,221.3,124.9,220.7,124.2,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.6,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,30.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,30.4,113.4,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,25.6c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C119.6,25.2,120.1,25.6,120.6,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,34.5,117.7,34,117,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,37.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,38.1,114.1,37.5,113.4,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,41.7,117.7,41.1,117,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,45.3,114.1,44.7,113.4,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,52.4,114.1,51.9,113.4,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,56,117.7,55.5,117,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,59.6,114.1,59.1,113.4,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,66.8,114.1,66.3,113.4,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,70.4,117.7,69.9,117,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,73.5,113.4,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,81.2,114.1,80.6,113.4,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,87.8,113.4,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,92,117.7,91.4,117,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,95.5,114.1,95,113.4,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,99.1,117.7,98.6,117,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,102.7,114.1,102.2,113.4,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,109.4,113.4,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,113.5,117.7,113,117,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,117.1,114.1,116.6,113.4,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,123.7,113.4,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C118.2,127.9,117.7,127.3,117,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,131.5,114.1,130.9,113.4,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,138.7,114.1,138.1,113.4,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,145.8,114.1,145.3,113.4,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C118.2,149.4,117.7,148.9,117,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,153,114.1,152.5,113.4,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,160.2,114.1,159.7,113.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C118.2,163.8,117.7,163.3,117,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,166.9,113.4,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C118.2,171,117.7,170.4,117,170.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,174.6,114.1,174,113.4,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,181.2,113.4,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C118.2,185.3,117.7,184.8,117,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,188.9,114.1,188.4,113.4,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,196.1,114.1,195.6,113.4,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,203.3,114.1,202.8,113.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C118.2,206.9,117.7,206.4,117,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,210.5,114.1,210,113.4,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C114.6,217.7,114.1,217.1,113.4,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C118.2,221.3,117.7,220.7,117,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S114.1,224.3,113.4,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.4,0.2,0.6l2.2-0.7C118.1,228.4,117.6,227.9,117,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,23.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,23.7,106.9,23.2,106.2,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.2,24.4c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.4-0.3-0.8-0.6-1l-0.6-0.2 C112.7,23.2,112.2,23.7,112.2,24.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 31.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C111,34.5,110.5,34,109.8,34z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,41.7,110.5,41.1,109.8,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,45.3,106.9,44.7,106.2,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,56,110.5,55.5,109.8,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,59.6,106.9,59.1,106.2,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,66.8,106.9,66.3,106.2,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,70.4,110.5,69.9,109.8,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,81.2,106.9,80.6,106.2,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,92,110.5,91.4,109.8,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,99.1,110.5,98.6,109.8,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,102.7,106.9,102.2,106.2,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,113.5,110.5,113,109.8,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,117.1,106.9,116.6,106.2,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,127.9,110.5,127.3,109.8,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,138.7,106.9,138.1,106.2,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,145.8,106.9,145.3,106.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,149.4,110.5,148.9,109.8,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,160.2,106.9,159.7,106.2,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,163.8,110.5,163.3,109.8,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,171,110.5,170.4,109.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C107.4,174.6,106.9,174,106.2,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,185.3,110.5,184.8,109.8,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,196.1,106.9,195.6,106.2,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,203.3,106.9,202.8,106.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,206.9,110.5,206.4,109.8,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C107.4,217.7,106.9,217.1,106.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.8,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C111,221.3,110.5,220.7,109.8,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106.2,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.8,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.4,232.6c0-0.6-0.5-1.1-1.2-1.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.5,0.2,0.7L107.4,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,22c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6c-0.1,0.2-0.1,0.3-0.1,0.5C101.5,21.4,102,22,102.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,23.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,23.7,99.7,23.2,99.1,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,26.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,27.3,103.3,26.8,102.7,26.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 31.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,34.5,103.3,34,102.7,34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,41.7,103.3,41.1,102.7,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,45.3,99.7,44.7,99.1,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,48.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,48.9,103.3,48.3,102.7,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,56,103.3,55.5,102.7,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,59.6,99.7,59.1,99.1,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,63.2,103.3,62.7,102.7,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,66.8,99.7,66.3,99.1,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,70.4,103.3,69.9,102.7,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,77.6,103.3,77.1,102.7,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,81.2,99.7,80.6,99.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,84.8,103.3,84.2,102.7,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,92,103.3,91.4,102.7,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,99.1,103.3,98.6,102.7,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,102.7,99.7,102.2,99.1,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,106.3,103.3,105.8,102.7,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,113.5,103.3,113,102.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,117.1,99.7,116.6,99.1,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,120.7,103.3,120.2,102.7,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,127.9,103.3,127.3,102.7,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S103.3,134.5,102.7,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,138.7,99.7,138.1,99.1,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,142.2,103.3,141.7,102.7,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,145.8,99.7,145.3,99.1,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,149.4,103.3,148.9,102.7,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S103.3,156.1,102.7,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,160.2,99.7,159.7,99.1,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,163.8,103.3,163.3,102.7,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,171,103.3,170.4,102.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,174.6,99.7,174,99.1,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S103.3,177.6,102.7,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,185.3,103.3,184.8,102.7,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S103.3,192,102.7,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,196.1,99.7,195.6,99.1,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,199.7,103.3,199.2,102.7,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,203.3,99.7,202.8,99.1,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,206.9,103.3,206.4,102.7,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,214.1,103.3,213.5,102.7,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,217.7,99.7,217.1,99.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,221.3,103.3,220.7,102.7,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.1,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C103.8,228.4,103.3,227.9,102.7,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C100.3,232,99.7,231.5,99.1,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 20.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,23.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,23.7,92.5,23.2,91.9,23.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,30.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,30.4,91.9,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,34.5,96.1,34,95.5,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,37.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,38.1,92.5,37.5,91.9,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,41.7,96.1,41.1,95.5,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,45.3,92.5,44.7,91.9,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,52.4,92.5,51.9,91.9,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,56,96.1,55.5,95.5,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,59.6,92.5,59.1,91.9,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,66.8,92.5,66.3,91.9,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,70.4,96.1,69.9,95.5,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,73.5,91.9,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,81.2,92.5,80.6,91.9,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,87.8,91.9,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,92,96.1,91.4,95.5,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C93.1,95.5,92.5,95,91.9,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,99.1,96.1,98.6,95.5,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,102.7,92.5,102.2,91.9,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,109.4,91.9,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,113.5,96.1,113,95.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,117.1,92.5,116.6,91.9,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,123.7,91.9,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C96.7,127.9,96.1,127.3,95.5,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,131.5,92.5,130.9,91.9,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,138.7,92.5,138.1,91.9,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,145.8,92.5,145.3,91.9,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C96.7,149.4,96.1,148.9,95.5,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,153,92.5,152.5,91.9,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,160.2,92.5,159.7,91.9,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C96.7,163.8,96.1,163.3,95.5,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,166.9,91.9,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C96.7,171,96.1,170.4,95.5,170.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,174.6,92.5,174,91.9,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,181.2,91.9,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C96.7,185.3,96.1,184.8,95.5,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,188.9,92.5,188.4,91.9,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,196.1,92.5,195.6,91.9,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,203.3,92.5,202.8,91.9,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C96.7,206.9,96.1,206.4,95.5,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,210.5,92.5,210,91.9,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,217.7,92.5,217.1,91.9,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C96.7,221.3,96.1,220.7,95.5,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S92.5,224.3,91.9,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.5,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C93.1,232,92.5,231.5,91.9,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.5,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.5,0.3,0.7l2.1-0.7c0,0,0,0,0,0 C96.7,235.6,96.1,235.1,95.5,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 20.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,23.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,23.7,85.4,23.2,84.7,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,18.4c0.3,0,0.6-0.1,0.9-0.4l-2-0.5C90.9,18,91.3,18.4,91.9,18.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 31.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C89.5,34.5,88.9,34,88.3,34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,41.7,88.9,41.1,88.3,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,45.3,85.4,44.7,84.7,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,56,88.9,55.5,88.3,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,59.6,85.4,59.1,84.7,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,66.8,85.4,66.3,84.7,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,70.4,88.9,69.9,88.3,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,81.2,85.4,80.6,84.7,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,92,88.9,91.4,88.3,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,99.1,88.9,98.6,88.3,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,102.7,85.4,102.2,84.7,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,113.5,88.9,113,88.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,117.1,85.4,116.6,84.7,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,127.9,88.9,127.3,88.3,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,138.7,85.4,138.1,84.7,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,145.8,85.4,145.3,84.7,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,149.4,88.9,148.9,88.3,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,160.2,85.4,159.7,84.7,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,163.8,88.9,163.3,88.3,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,171,88.9,170.4,88.3,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,174.6,85.4,174,84.7,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,185.3,88.9,184.8,88.3,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,196.1,85.4,195.6,84.7,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,203.3,85.4,202.8,84.7,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,206.9,88.9,206.4,88.3,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C85.9,217.7,85.4,217.1,84.7,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.3,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C89.5,221.3,88.9,220.7,88.3,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.7,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C85.9,232,85.4,231.5,84.7,231.5z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.3,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,238.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.6,0.3,0.8l2-0.7c0,0,0-0.1,0-0.1 C85.9,239.2,85.4,238.7,84.7,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,16c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C78.7,16.5,78.2,16,77.5,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.5,17.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2c0-0.4-0.3-0.8-0.6-1L84.6,16C84,16,83.5,16.5,83.5,17.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 20.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,23.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,23.7,78.2,23.2,77.5,23.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,30.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,30.4,77.5,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,34.5,81.8,34,81.1,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,37.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,38.1,78.2,37.5,77.5,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,41.7,81.8,41.1,81.1,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,45.3,78.2,44.7,77.5,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,51.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,52.4,78.2,51.9,77.5,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,56,81.8,55.5,81.1,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,59.6,78.2,59.1,77.5,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,66.8,78.2,66.3,77.5,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,70.4,81.8,69.9,81.1,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,73.5,77.5,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,81.2,78.2,80.6,77.5,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,87.8,77.5,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,92,81.8,91.4,81.1,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C78.7,95.5,78.2,95,77.5,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,99.1,81.8,98.6,81.1,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,102.7,78.2,102.2,77.5,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,109.4,77.5,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,113.5,81.8,113,81.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,117.1,78.2,116.6,77.5,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,123.7,77.5,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C82.3,127.9,81.8,127.3,81.1,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,131.5,78.2,130.9,77.5,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,138.7,78.2,138.1,77.5,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,145.8,78.2,145.3,77.5,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C82.3,149.4,81.8,148.9,81.1,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,153,78.2,152.5,77.5,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,160.2,78.2,159.7,77.5,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C82.3,163.8,81.8,163.3,81.1,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,166.9,77.5,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C82.3,171,81.8,170.4,81.1,170.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,174.6,78.2,174,77.5,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,181.2,77.5,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C82.3,185.3,81.8,184.8,81.1,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,188.9,78.2,188.4,77.5,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,196.1,78.2,195.6,77.5,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,203.3,78.2,202.8,77.5,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C82.3,206.9,81.8,206.4,81.1,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,210.5,78.2,210,77.5,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,217.7,78.2,217.1,77.5,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.1,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C82.3,221.3,81.8,220.7,81.1,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,224.3,77.5,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C78.7,232,78.2,231.5,77.5,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.1,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S78.2,238.7,77.5,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.7,13.6c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2l-2.2-0.6C72.8,13.2,72.7,13.4,72.7,13.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 17.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 20.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,23.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,23.7,71,23.2,70.3,23.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 28,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 31.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,34.5,74.6,34,73.9,34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,41.7,74.6,41.1,73.9,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,45.3,71,44.7,70.3,44.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 49.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,56,74.6,55.5,73.9,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,59.6,71,59.1,70.3,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,66.8,71,66.3,70.3,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,70.4,74.6,69.9,73.9,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,81.2,71,80.6,70.3,80.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,92,74.6,91.4,73.9,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,99.1,74.6,98.6,73.9,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,102.7,71,102.2,70.3,102.2z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,113.5,74.6,113,73.9,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,117.1,71,116.6,70.3,116.6z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C75.1,127.9,74.6,127.3,73.9,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,138.7,71,138.1,70.3,138.1z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,145.8,71,145.3,70.3,145.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C75.1,149.4,74.6,148.9,73.9,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,160.2,71,159.7,70.3,159.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C75.1,163.8,74.6,163.3,73.9,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C75.1,171,74.6,170.4,73.9,170.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,174.6,71,174,70.3,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C75.1,185.3,74.6,184.8,73.9,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,196.1,71,195.6,70.3,195.6z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,203.3,71,202.8,70.3,202.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C75.1,206.9,74.6,206.4,73.9,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,217.7,71,217.1,70.3,217.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C75.1,221.3,74.6,220.7,73.9,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C71.5,232,71,231.5,70.3,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 73.9,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.2,0.7,0.4,0.9l2-0.7c0-0.1,0-0.1,0-0.2 C75.1,242.8,74.6,242.3,73.9,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,13.6c0-0.2-0.1-0.4-0.2-0.6l-0.4,1.7C67.7,14.4,67.9,14,67.9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,22c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.3,0-0.5,0.1-0.7,0.3l-0.4,1.4 C65.8,21.7,66.2,22,66.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,26.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,27.3,67.4,26.8,66.7,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,34c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C67.9,34.5,67.4,34,66.7,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,31.6c0-0.6-0.4-1.1-1-1.2l-0.6,2.3c0.1,0,0.2,0.1,0.4,0.1C63.8,32.8,64.3,32.2,64.3,31.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,41.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,41.7,67.4,41.1,66.7,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,44.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,45.3,63.8,44.7,63.1,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,48.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,48.9,67.4,48.3,66.7,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 53.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,56,67.4,55.5,66.7,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,59.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,59.6,63.8,59.1,63.1,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,62.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,63.2,67.4,62.7,66.7,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,66.8,63.8,66.3,63.1,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,70.4,67.4,69.9,66.7,69.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 74.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,77.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,77.6,67.4,77.1,66.7,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,81.2,63.8,80.6,63.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,84.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,84.8,67.4,84.2,66.7,84.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 89,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,92,67.4,91.4,66.7,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,99.1,67.4,98.6,66.7,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,102.7,63.8,102.2,63.1,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,105.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,106.3,67.4,105.8,66.7,105.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,113.5,67.4,113,66.7,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,117.1,63.8,116.6,63.1,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,120.7,67.4,120.2,66.7,120.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,127.9,67.4,127.3,66.7,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S67.4,134.5,66.7,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,138.7,63.8,138.1,63.1,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,142.2,67.4,141.7,66.7,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,145.8,63.8,145.3,63.1,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,149.4,67.4,148.9,66.7,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S67.4,156.1,66.7,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,160.2,63.8,159.7,63.1,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,163.8,67.4,163.3,66.7,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,171,67.4,170.4,66.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,174.6,63.8,174,63.1,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S67.4,177.6,66.7,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,185.3,67.4,184.8,66.7,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S67.4,192,66.7,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,196.1,63.8,195.6,63.1,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,199.7,67.4,199.2,66.7,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,203.3,63.8,202.8,63.1,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,206.9,67.4,206.4,66.7,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,214.1,67.4,213.5,66.7,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,217.7,63.8,217.1,63.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,221.3,67.4,220.7,66.7,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,228.4,67.4,227.9,66.7,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C64.3,232,63.8,231.5,63.1,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,235.6,67.4,235.1,66.7,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.1,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C67.9,242.8,67.4,242.3,66.7,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.2,0.7,0.5,0.9l1.9-0.6c0-0.1,0.1-0.2,0.1-0.3 C64.3,246.4,63.8,245.9,63.1,245.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.3,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.7,42.3c0-0.3-0.1-0.5-0.2-0.7L60,43.4C60.5,43.2,60.7,42.8,60.7,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,50.7c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.3,0-0.6,0.1-0.8,0.3l-0.3,1.2 C58.6,50.3,59,50.7,59.5,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,55.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,56,60.2,55.5,59.5,55.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 63.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.2,60.3c0-0.6-0.5-1.1-1.1-1.2l-0.6,2.3c0.1,0.1,0.3,0.1,0.4,0.1C56.6,61.5,57.2,61,57.2,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,66.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C57.2,66.8,56.6,66.3,56,66.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,69.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,70.4,60.2,69.9,59.5,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,73.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,73.5,56,73.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 78.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,80.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C57.2,81.2,56.6,80.6,56,80.6z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,87.8c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,87.8,56,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,92,60.2,91.4,59.5,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,95c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C57.2,95.5,56.6,95,56,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,99.1,60.2,98.6,59.5,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,102.7,56.6,102.2,56,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,109.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,109.4,56,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,113.5,60.2,113,59.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,117.1,56.6,116.6,56,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,123.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,123.7,56,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,127.9,60.2,127.3,59.5,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,130.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,131.5,56.6,130.9,56,130.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,138.7,56.6,138.1,56,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,145.8,56.6,145.3,56,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,149.4,60.2,148.9,59.5,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,153,56.6,152.5,56,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,160.2,56.6,159.7,56,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,163.8,60.2,163.3,59.5,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,166.9,56,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,171,60.2,170.4,59.5,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C57.2,174.6,56.6,174,56,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,181.2,56,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,185.3,60.2,184.8,59.5,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,188.9,56.6,188.4,56,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,196.1,56.6,195.6,56,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,203.3,56.6,202.8,56,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,206.9,60.2,206.4,59.5,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C57.2,210.5,56.6,210,56,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,217.7,56.6,217.1,56,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,221.3,60.2,220.7,59.5,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,224.3,56,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,232,56.6,231.5,56,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.5,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S56.6,238.7,56,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C60.7,242.8,60.2,242.3,59.5,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C57.2,246.4,56.6,245.9,56,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.6,71.1c0-0.3-0.1-0.6-0.3-0.8l-0.5,1.9C53.2,72,53.6,71.6,53.6,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,79.4c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.4,0-0.7,0.2-0.9,0.5l-0.2,0.9 C51.3,79,51.8,79.4,52.4,79.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 85.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,91.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C53.6,92,53,91.4,52.4,91.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,89c0-0.6-0.5-1.1-1.1-1.2l-0.6,2.3c0.2,0.1,0.3,0.1,0.5,0.1C49.4,90.2,50,89.7,50,89z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 96.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,98.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,99.1,53,98.6,52.4,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,102.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,102.7,49.4,102.2,48.8,102.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 110.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C53.6,113.5,53,113,52.4,113z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,116.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,117.1,49.4,116.6,48.8,116.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,127.9,53,127.3,52.4,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,138.7,49.4,138.1,48.8,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,145.8,49.4,145.3,48.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,149.4,53,148.9,52.4,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,160.2,49.4,159.7,48.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,163.8,53,163.3,52.4,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,171,53,170.4,52.4,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C50,174.6,49.4,174,48.8,174z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,185.3,53,184.8,52.4,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,196.1,49.4,195.6,48.8,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,203.3,49.4,202.8,48.8,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,206.9,53,206.4,52.4,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,217.7,49.4,217.1,48.8,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,221.3,53,220.7,52.4,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C50,232,49.4,231.5,48.8,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 52.4,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C53.6,242.8,53,242.3,52.4,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.8,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.2,0.8,0.6,1l1.7-0.6c0-0.1,0.1-0.3,0.1-0.4 C53.6,250,53,249.5,52.4,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.4,99.8c0-0.3-0.1-0.6-0.3-0.8l-0.5,2C46,100.8,46.4,100.3,46.4,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,108.2c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.4,0-0.8,0.3-1,0.6L44,107 C44,107.7,44.5,108.2,45.2,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,113c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,113.5,45.8,113,45.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,120.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,120.7,45.8,120.2,45.2,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.8,117.8c0-0.7-0.5-1.2-1.2-1.2l-0.6,2.2c0.2,0.1,0.4,0.2,0.6,0.2C42.2,119,42.8,118.4,42.8,117.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 124.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,127.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,127.9,45.8,127.3,45.2,127.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 132.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S45.8,134.5,45.2,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,138.7,42.2,138.1,41.6,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,142.2,45.8,141.7,45.2,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,145.8,42.2,145.3,41.6,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,149.4,45.8,148.9,45.2,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S45.8,156.1,45.2,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,160.2,42.2,159.7,41.6,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,163.8,45.8,163.3,45.2,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,171,45.8,170.4,45.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,174.6,42.2,174,41.6,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S45.8,177.6,45.2,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,185.3,45.8,184.8,45.2,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S45.8,192,45.2,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,196.1,42.2,195.6,41.6,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,199.7,45.8,199.2,45.2,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,203.3,42.2,202.8,41.6,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,206.9,45.8,206.4,45.2,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,214.1,45.8,213.5,45.2,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,217.7,42.2,217.1,41.6,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,221.3,45.8,220.7,45.2,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,228.4,45.8,227.9,45.2,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C42.8,232,42.2,231.5,41.6,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,235.6,45.8,235.1,45.2,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,242.8,45.8,242.3,45.2,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.6,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C46.4,250,45.8,249.5,45.2,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.5,0.3,0.9,0.7,1.1l1.6-0.6c0.1-0.2,0.1-0.3,0.1-0.5 C42.8,253.6,42.2,253.1,41.6,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,128.5c0-0.4-0.2-0.7-0.4-0.9l-0.5,2C38.8,129.5,39.2,129.1,39.2,128.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,149.4,38.7,148.9,38,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.6,146.5c0-0.7-0.5-1.2-1.2-1.2c0,0,0,0-0.1,0l-0.6,2.2c0.2,0.1,0.4,0.2,0.6,0.2 C35.1,147.7,35.6,147.2,35.6,146.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,160.2,35.1,159.7,34.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,163.8,38.7,163.3,38,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,171,38.7,170.4,38,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,174.6,35.1,174,34.4,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,185.3,38.7,184.8,38,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,196.1,35.1,195.6,34.4,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,203.3,35.1,202.8,34.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,206.9,38.7,206.4,38,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,217.7,35.1,217.1,34.4,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,221.3,38.7,220.7,38,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,232,35.1,231.5,34.4,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,242.8,38.7,242.3,38,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.4,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C39.2,250,38.7,249.5,38,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C35.6,253.6,35.1,253.1,34.4,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,157.3c0-0.4-0.2-0.7-0.5-0.9l-0.5,2.1C31.6,158.3,32,157.9,32,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,163.8,31.5,163.3,30.8,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,171,31.5,170.4,30.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S31.5,177.6,30.8,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,175.2c0-0.7-0.5-1.2-1.2-1.2c0,0-0.1,0-0.1,0l-0.5,2.1c0.2,0.1,0.4,0.2,0.7,0.2 C27.9,176.4,28.4,175.9,28.4,175.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.2,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,185.3,31.5,184.8,30.8,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.2,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S31.5,192,30.8,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C28.4,196.1,27.9,195.6,27.2,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,199.7,31.5,199.2,30.8,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C28.4,203.3,27.9,202.8,27.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,206.9,31.5,206.4,30.8,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.2,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,214.1,31.5,213.5,30.8,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C28.4,217.7,27.9,217.1,27.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,221.3,31.5,220.7,30.8,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.2,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,228.4,31.5,227.9,30.8,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C28.4,232,27.9,231.5,27.2,231.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,235.6,31.5,235.1,30.8,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.2,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,242.8,31.5,242.3,30.8,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.2,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C32,250,31.5,249.5,30.8,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C28.4,253.6,27.9,253.1,27.2,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.5,0.3,0.9,0.8,1.1l1.4-0.5c0.1-0.2,0.2-0.4,0.2-0.6 C32,257.2,31.5,256.6,30.8,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,186c0-0.4-0.2-0.7-0.5-1l-0.5,2.1C24.4,187.1,24.8,186.6,24.8,186z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.6,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.6,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.6,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C24.8,206.9,24.3,206.4,23.6,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,204c0-0.7-0.5-1.2-1.2-1.2c-0.1,0-0.1,0-0.2,0l-0.5,2.1c0.2,0.2,0.4,0.3,0.7,0.3 C20.7,205.2,21.2,204.6,21.2,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C21.2,210.5,20.7,210,20,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.6,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C21.2,217.7,20.7,217.1,20,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.6,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C24.8,221.3,24.3,220.7,23.6,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S20.7,224.3,20,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.6,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C21.2,232,20.7,231.5,20,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.6,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S20.7,238.7,20,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.6,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C24.8,242.8,24.3,242.3,23.6,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C21.2,246.4,20.7,245.9,20,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.6,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C24.8,250,24.3,249.5,23.6,249.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C21.2,253.6,20.7,253.1,20,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.6,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.6,0.4,1,0.9,1.1l1.2-0.4c0.2-0.2,0.3-0.5,0.3-0.7 C21.2,260.8,20.7,260.2,20,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.6,214.7c0-0.4-0.2-0.8-0.6-1l-0.5,2.2C17.1,215.9,17.6,215.4,17.6,214.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C17.6,221.3,17.1,220.7,16.4,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.4,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.4,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,232.7c0-0.7-0.5-1.2-1.2-1.2c-0.1,0-0.2,0-0.3,0.1l-0.5,2c0.2,0.2,0.5,0.3,0.8,0.3 C13.5,233.9,14,233.4,14,232.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.9,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C17.6,242.8,17.1,242.3,16.4,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.9,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C17.6,250,17.1,249.5,16.4,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C14,253.6,13.5,253.1,12.9,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.4,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.9,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,243.5c0-0.4-0.3-0.8-0.6-1l-0.6,2.2C9.9,244.7,10.5,244.1,10.5,243.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C10.5,250,9.9,249.5,9.3,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C10.5,257.2,9.9,256.6,9.3,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.7,254.8c0.1-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0,0L6.7,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,265c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.1,1.1,1.2l0.9-0.3 C10.3,265.7,10.5,265.4,10.5,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,261.4c0-0.7-0.5-1.2-1.2-1.2c-0.1,0-0.2,0-0.3,0.1l-0.5,2c0.2,0.2,0.5,0.3,0.8,0.3 C6.3,262.6,6.9,262.1,6.9,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,267.6l0.3-0.1C5.3,267.5,5.2,267.5,5.1,267.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.5,224.8c-0.2-0.3-0.5-0.5-0.9-0.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.5,0,0.8-0.3,1-0.6 L588.5,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,232,588.2,231.5,587.6,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S588.2,238.7,587.6,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M590.1,244.1l-0.1-1.1c-0.1,0.1-0.1,0.3-0.1,0.5C590,243.7,590,243.9,590.1,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,246.4,588.2,245.9,587.6,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M590.8,251.8l-0.2-2.2c-0.4,0.2-0.7,0.6-0.7,1.1C590,251.2,590.3,251.6,590.8,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,253.6,588.2,253.1,587.6,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,259c0.1,0,0.2,0,0.3-0.1l-0.2-2.3c0,0,0,0-0.1,0c-0.7,0-1.2,0.5-1.2,1.2 C590,258.5,590.5,259,591.1,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,260.8,588.2,260.2,587.6,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.3,0,0.6-0.1,0.9-0.4l-0.2-1.8 C591.7,263.9,591.4,263.8,591.1,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,268,588.2,267.4,587.6,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C592.3,271.6,591.8,271,591.1,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,275.1,588.2,274.6,587.6,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C592.3,278.7,591.8,278.2,591.1,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,282.3,588.2,281.8,587.6,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C592.3,285.9,591.8,285.4,591.1,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,289.5,588.2,289,587.6,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.5,290.2c0,0.4,0.3,0.8,0.6,1l-0.2-1.9C593.7,289.5,593.5,289.8,593.5,290.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,292.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C592.3,293.1,591.8,292.6,591.1,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,296.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C588.8,296.7,588.2,296.2,587.6,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.5,297.4c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0l-0.2-2.4C594,296.3,593.5,296.7,593.5,297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.1,299.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C592.3,300.3,591.8,299.8,591.1,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.1,138.4c-0.2-0.2-0.5-0.3-0.7-0.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.4,0,0.7-0.2,0.9-0.4 L581.1,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,145.8,581,145.3,580.4,145.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,160.2,581,159.7,580.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M582.8,164.5c0,0.5,0.3,0.9,0.7,1.1l-0.2-2C583,163.7,582.8,164.1,582.8,164.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M582.8,171.6c0,0.7,0.5,1.2,1.2,1.2c0,0,0.1,0,0.1,0l-0.2-2.4C583.2,170.5,582.8,171,582.8,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,174.6,581,174,580.4,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.3,0,0.5-0.1,0.7-0.2l-0.2-2 C584.3,177.7,584.2,177.6,584,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C585.2,185.3,584.6,184.8,584,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -23.3694 95.8121)",
    className: "st1",
    cx: 584,
    cy: 193.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,196.1,581,195.6,580.4,195.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -24.5175 95.9045)",
    className: "st1",
    cx: 584,
    cy: 200.4,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,203.3,581,202.8,580.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C585.2,206.9,584.6,206.4,584,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M586.8,204.9l-0.1-1.7c-0.2,0.2-0.3,0.5-0.3,0.8C586.4,204.3,586.5,204.6,586.8,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M586.4,211.1c0,0.6,0.5,1.1,1.1,1.2l-0.2-2.3C586.7,210.2,586.4,210.6,586.4,211.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -26.8137 96.0891)",
    className: "st1",
    cx: 584,
    cy: 214.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,217.7,581,217.1,580.4,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C585.2,221.3,584.6,220.7,584,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.6,219.5c0.2,0,0.3,0,0.5-0.1l-0.2-2.2c-0.1,0-0.2-0.1-0.3-0.1c-0.7,0-1.2,0.5-1.2,1.2 C586.4,219,586.9,219.5,587.6,219.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -29.11 96.2738)",
    className: "st1",
    cx: 584,
    cy: 229.1,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,232,581,231.5,580.4,231.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -30.2581 96.3661)",
    className: "st1",
    cx: 584,
    cy: 236.3,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C585.2,242.8,584.6,242.3,584,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C585.2,250,584.6,249.5,584,249.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,253.6,581,253.1,580.4,253.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -33.7024 96.6432)",
    className: "st1",
    cx: 584,
    cy: 257.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C585.2,264.4,584.6,263.8,584,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,268,581,267.4,580.4,267.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -35.9986 96.8278)",
    className: "st1",
    cx: 584,
    cy: 272.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,275.1,581,274.6,580.4,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C585.2,278.7,584.6,278.2,584,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -38.2948 97.0125)",
    className: "st1",
    cx: 584,
    cy: 286.6,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.4,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C581.6,289.5,581,289,580.4,289z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -39.4429 97.1049)",
    className: "st1",
    cx: 584,
    cy: 293.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 580.4,
    cy: 297.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585.2,300.9c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2c0,0.3,0.1,0.6,0.4,0.9l1.5,0.1 C584.9,301.7,585.2,301.4,585.2,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M579.2,132.1c0,0.7,0.5,1.2,1.2,1.2c0.1,0,0.2,0,0.3-0.1l-0.2-2.3c0,0-0.1,0-0.1,0 C579.7,130.9,579.2,131.5,579.2,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,134.5c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S577.4,134.5,576.8,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,138.7,573.9,138.1,573.2,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,141.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,142.2,577.4,141.7,576.8,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,145.8,573.9,145.3,573.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,149.4,577.4,148.9,576.8,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S577.4,156.1,576.8,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,160.2,573.9,159.7,573.2,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,163.8,577.4,163.3,576.8,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,171,577.4,170.4,576.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,174.6,573.9,174,573.2,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S577.4,177.6,576.8,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,185.3,577.4,184.8,576.8,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S577.4,192,576.8,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,196.1,573.9,195.6,573.2,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,199.7,577.4,199.2,576.8,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,203.3,573.9,202.8,573.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,206.9,577.4,206.4,576.8,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,214.1,577.4,213.5,576.8,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,217.7,573.9,217.1,573.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,221.3,577.4,220.7,576.8,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,228.4,577.4,227.9,576.8,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,232,573.9,231.5,573.2,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,235.6,577.4,235.1,576.8,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,242.8,577.4,242.3,576.8,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,250,577.4,249.5,576.8,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,253.6,573.9,253.1,573.2,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,257.2,577.4,256.6,576.8,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,264.4,577.4,263.8,576.8,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,268,573.9,267.4,573.2,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C578,271.6,577.4,271,576.8,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,275.1,573.9,274.6,573.2,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,278.7,577.4,278.2,576.8,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,285.9,577.4,285.4,576.8,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.2,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C574.4,289.5,573.9,289,573.2,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M576.8,292.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C578,293.1,577.4,292.6,576.8,292.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573.2,
    cy: 297.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M578,300.9c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2c0,0.1,0,0.1,0,0.2l2.3,0.2 C577.9,301.2,578,301.1,578,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,136.9c0.7,0,1.2-0.5,1.2-1.2c0-0.2-0.1-0.4-0.2-0.6l-2,1.2C568.8,136.7,569.2,136.9,569.6,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,138.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,138.7,566.7,138.1,566,138.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,145.8,566.7,145.3,566,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,149.4,570.3,148.9,569.6,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,153,566.7,152.5,566,152.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,160.2,566.7,159.7,566,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,163.8,570.3,163.3,569.6,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S566.7,166.9,566,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,171,570.3,170.4,569.6,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,174.6,566.7,174,566,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S566.7,181.2,566,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,185.3,570.3,184.8,569.6,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,188.9,566.7,188.4,566,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,196.1,566.7,195.6,566,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,203.3,566.7,202.8,566,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,206.9,570.3,206.4,569.6,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,210.5,566.7,210,566,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,217.7,566.7,217.1,566,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,221.3,570.3,220.7,569.6,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S566.7,224.3,566,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,232,566.7,231.5,566,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S566.7,238.7,566,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,242.8,570.3,242.3,569.6,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,246.4,566.7,245.9,566,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,250,570.3,249.5,569.6,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,253.6,566.7,253.1,566,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,260.8,566.7,260.2,566,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,264.4,570.3,263.8,569.6,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,268,566.7,267.4,566,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,275.1,566.7,274.6,566,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C570.8,278.7,570.3,278.2,569.6,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,282.3,566.7,281.8,566,281.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,289.5,566.7,289,566,289z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 569.6,
    cy: 293.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566,296.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C567.2,296.7,566.7,296.2,566,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.6,299.8c-0.5,0-0.9,0.3-1.1,0.8l2.3,0.2C570.6,300.2,570.2,299.8,569.6,299.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 142.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,145.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,145.8,559.5,145.3,558.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,149.4,563.1,148.9,562.4,148.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 157.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,160.2,559.5,159.7,558.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,163.8,563.1,163.3,562.4,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,171,563.1,170.4,562.4,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C560,174.6,559.5,174,558.8,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,185.3,563.1,184.8,562.4,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,196.1,559.5,195.6,558.8,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,203.3,559.5,202.8,558.8,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,206.9,563.1,206.4,562.4,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,217.7,559.5,217.1,558.8,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,221.3,563.1,220.7,562.4,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,232,559.5,231.5,558.8,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,242.8,563.1,242.3,562.4,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,250,563.1,249.5,562.4,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,253.6,559.5,253.1,558.8,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,264.4,563.1,263.8,562.4,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,268,559.5,267.4,558.8,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C560,275.1,559.5,274.6,558.8,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C563.6,278.7,563.1,278.2,562.4,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C560,289.5,559.5,289,558.8,289z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 562.4,
    cy: 293.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 558.8,
    cy: 297.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.4,299.8c-0.2,0-0.4,0.1-0.6,0.2l1.3,0.1C563,299.9,562.7,299.8,562.4,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,148.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,149.4,555.9,148.9,555.2,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,152.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,153,552.3,152.5,551.6,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S555.9,156.1,555.2,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,160.2,552.3,159.7,551.6,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,163.8,555.9,163.3,555.2,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S552.3,166.9,551.6,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,171,555.9,170.4,555.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,174.6,552.3,174,551.6,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S555.9,177.6,555.2,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S552.3,181.2,551.6,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,185.3,555.9,184.8,555.2,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,188.9,552.3,188.4,551.6,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S555.9,192,555.2,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,196.1,552.3,195.6,551.6,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,199.7,555.9,199.2,555.2,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,203.3,552.3,202.8,551.6,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,206.9,555.9,206.4,555.2,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,210.5,552.3,210,551.6,210z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,214.1,555.9,213.5,555.2,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,217.7,552.3,217.1,551.6,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,221.3,555.9,220.7,555.2,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S552.3,224.3,551.6,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,228.4,555.9,227.9,555.2,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,232,552.3,231.5,551.6,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,235.6,555.9,235.1,555.2,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S552.3,238.7,551.6,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,242.8,555.9,242.3,555.2,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,246.4,552.3,245.9,551.6,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,250,555.9,249.5,555.2,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,253.6,552.3,253.1,551.6,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,257.2,555.9,256.6,555.2,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,260.8,552.3,260.2,551.6,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,264.4,555.9,263.8,555.2,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,268,552.3,267.4,551.6,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C556.4,271.6,555.9,271,555.2,271z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,275.1,552.3,274.6,551.6,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,278.7,555.9,278.2,555.2,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,282.3,552.3,281.8,551.6,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,285.9,555.9,285.4,555.2,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,289.5,552.3,289,551.6,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.2,292.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C556.4,293.1,555.9,292.6,555.2,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,296.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C552.8,296.7,552.3,296.2,551.6,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,151.3c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.1,0-0.1,0-0.2,0l-0.8,0.5 c-0.1,0.2-0.3,0.4-0.3,0.7C546.8,150.7,547.4,151.3,548,151.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 153.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.6,147.7c0.7,0,1.2-0.5,1.2-1.2c0-0.2-0.1-0.4-0.1-0.5l-2,1.2C550.9,147.5,551.2,147.7,551.6,147.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -18.0891 89.5977)",
    className: "st1",
    cx: 548,
    cy: 157.3,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,160.2,545.1,159.7,544.5,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,163.8,548.7,163.3,548,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C549.2,171,548.7,170.4,548,170.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,174.6,545.1,174,544.5,174z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -21.533 89.8746)",
    className: "st1",
    cx: 548,
    cy: 178.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,185.3,548.7,184.8,548,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -23.8289 90.0592)",
    className: "st1",
    cx: 548,
    cy: 193.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,196.1,545.1,195.6,544.5,195.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -24.9768 90.1516)",
    className: "st1",
    cx: 548,
    cy: 200.4,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,203.3,545.1,202.8,544.5,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,206.9,548.7,206.4,548,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -27.2727 90.3362)",
    className: "st1",
    cx: 548,
    cy: 214.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,217.7,545.1,217.1,544.5,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,221.3,548.7,220.7,548,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -29.5687 90.5208)",
    className: "st1",
    cx: 548,
    cy: 229.1,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,232,545.1,231.5,544.5,231.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -30.7166 90.6131)",
    className: "st1",
    cx: 548,
    cy: 236.3,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,242.8,548.7,242.3,548,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C549.2,250,548.7,249.5,548,249.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,253.6,545.1,253.1,544.5,253.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -34.1605 90.8901)",
    className: "st1",
    cx: 548,
    cy: 257.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,264.4,548.7,263.8,548,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,268,545.1,267.4,544.5,267.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -36.4564 91.0747)",
    className: "st1",
    cx: 548,
    cy: 272.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,275.1,545.1,274.6,544.5,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C549.2,278.7,548.7,278.2,548,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 544.5,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -38.7523 91.2593)",
    className: "st1",
    cx: 548,
    cy: 286.6,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.5,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.7,289.5,545.1,289,544.5,289z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1598 0.1598 0.9871 -39.9003 91.3516)",
    className: "st1",
    cx: 548,
    cy: 293.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.7,297.4c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.2,0.8,0.5,1l1.2,0.1 C545.4,298.2,545.7,297.8,545.7,297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,156.1c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S541.5,156.1,540.9,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,159.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,160.2,537.9,159.7,537.3,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,163.8,541.5,163.3,540.9,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,171,541.5,170.4,540.9,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C538.5,174.6,537.9,174,537.3,174z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S541.5,177.6,540.9,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,185.3,541.5,184.8,540.9,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S541.5,192,540.9,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,196.1,537.9,195.6,537.3,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,199.7,541.5,199.2,540.9,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,203.3,537.9,202.8,537.3,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,206.9,541.5,206.4,540.9,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,214.1,541.5,213.5,540.9,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,217.7,537.9,217.1,537.3,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,221.3,541.5,220.7,540.9,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,228.4,541.5,227.9,540.9,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,232,537.9,231.5,537.3,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,235.6,541.5,235.1,540.9,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,242.8,541.5,242.3,540.9,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,250,541.5,249.5,540.9,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,253.6,537.9,253.1,537.3,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,257.2,541.5,256.6,540.9,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,264.4,541.5,263.8,540.9,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,268,537.9,267.4,537.3,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,271.6,541.5,271,540.9,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C538.5,275.1,537.9,274.6,537.3,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,278.7,541.5,278.2,540.9,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 537.3,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,285.9,541.5,285.4,540.9,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C538.5,289.5,537.9,289,537.3,289z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.9,292.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C542.1,293.1,541.5,292.6,540.9,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.3,296.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.2,0.1,0.3l2.2,0.2c0.1-0.2,0.1-0.3,0.1-0.5 C538.5,296.7,537.9,296.2,537.3,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,158.5c0.7,0,1.2-0.5,1.2-1.2c0-0.1,0-0.3-0.1-0.4l-2,1.2C533,158.3,533.3,158.5,533.7,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,163.8,534.3,163.3,533.7,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,166.9c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S530.7,166.9,530.1,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,171,534.3,170.4,533.7,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,174.6,530.7,174,530.1,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S530.7,181.2,530.1,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,185.3,534.3,184.8,533.7,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,188.9,530.7,188.4,530.1,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,196.1,530.7,195.6,530.1,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,203.3,530.7,202.8,530.1,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,206.9,534.3,206.4,533.7,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,210.5,530.7,210,530.1,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,217.7,530.7,217.1,530.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,221.3,534.3,220.7,533.7,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S530.7,224.3,530.1,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,232,530.7,231.5,530.1,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S530.7,238.7,530.1,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,242.8,534.3,242.3,533.7,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,246.4,530.7,245.9,530.1,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,250,534.3,249.5,533.7,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,253.6,530.7,253.1,530.1,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,260.8,530.7,260.2,530.1,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,264.4,534.3,263.8,533.7,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,268,530.7,267.4,530.1,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,275.1,530.7,274.6,530.1,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C534.9,278.7,534.3,278.2,533.7,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,282.3,530.7,281.8,530.1,281.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C531.3,289.5,530.7,289,530.1,289z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.7,
    cy: 293.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,296.2c-0.5,0-1,0.4-1.1,0.9l2.3,0.2C531.2,296.6,530.7,296.2,530.1,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,163.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,163.8,527.2,163.3,526.5,163.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 168,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.1,162.1c0.7,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.1-1.1-1.2l-1.2,0.7c-0.1,0.1-0.1,0.3-0.1,0.5 C528.9,161.5,529.4,162.1,530.1,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,171,527.2,170.4,526.5,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,174.6,523.6,174,522.9,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,185.3,527.2,184.8,526.5,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,196.1,523.6,195.6,522.9,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,203.3,523.6,202.8,522.9,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,206.9,527.2,206.4,526.5,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,217.7,523.6,217.1,522.9,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,221.3,527.2,220.7,526.5,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,232,523.6,231.5,522.9,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,242.8,527.2,242.3,526.5,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,250,527.2,249.5,526.5,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,253.6,523.6,253.1,522.9,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,264.4,527.2,263.8,526.5,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,268,523.6,267.4,522.9,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,275.1,523.6,274.6,522.9,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.5,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C527.7,278.7,527.2,278.2,526.5,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 522.9,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C524.1,289.5,523.6,289,522.9,289z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 526.5,
    cy: 293.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.9,296.2c-0.3,0-0.5,0.1-0.7,0.3l1.6,0.1C523.6,296.3,523.3,296.2,522.9,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,170.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,171,520,170.4,519.3,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.9,168c0-0.1,0-0.2-0.1-0.3l-1.9,1.2c0.2,0.2,0.5,0.3,0.8,0.3C516.4,169.2,516.9,168.7,516.9,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,174.6,516.4,174,515.7,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,177.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S520,177.6,519.3,177.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,185.3,520,184.8,519.3,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S520,192,519.3,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,196.1,516.4,195.6,515.7,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,199.7,520,199.2,519.3,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,203.3,516.4,202.8,515.7,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,206.9,520,206.4,519.3,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,214.1,520,213.5,519.3,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,217.7,516.4,217.1,515.7,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,221.3,520,220.7,519.3,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,228.4,520,227.9,519.3,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,232,516.4,231.5,515.7,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,235.6,520,235.1,519.3,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,242.8,520,242.3,519.3,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,250,520,249.5,519.3,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,253.6,516.4,253.1,515.7,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,257.2,520,256.6,519.3,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,264.4,520,263.8,519.3,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,268,516.4,267.4,515.7,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C520.5,271.6,520,271,519.3,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,275.1,516.4,274.6,515.7,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,278.7,520,278.2,519.3,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 515.7,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,285.9,520,285.4,519.3,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.7,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C516.9,289.5,516.4,289,515.7,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.3,292.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C520.5,293.1,520,292.6,519.3,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,172.8c0.7,0,1.2-0.5,1.2-1.2c0-0.6-0.4-1-0.9-1.1l-1.4,0.9c0,0.1-0.1,0.2-0.1,0.3 C510.9,172.3,511.5,172.8,512.1,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,174c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,174.6,509.2,174,508.5,174z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -21.9922 84.1219)",
    className: "st1",
    cx: 512.1,
    cy: 178.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,181.2c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S509.2,181.2,508.5,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,185.3,512.8,184.8,512.1,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,188.9,509.2,188.4,508.5,188.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -24.2878 84.3064)",
    className: "st1",
    cx: 512.1,
    cy: 193.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,196.1,509.2,195.6,508.5,195.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -25.4356 84.3987)",
    className: "st1",
    cx: 512.1,
    cy: 200.4,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,203.3,509.2,202.8,508.5,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,206.9,512.8,206.4,512.1,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,210.5,509.2,210,508.5,210z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -27.7312 84.5833)",
    className: "st1",
    cx: 512.1,
    cy: 214.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,217.7,509.2,217.1,508.5,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,221.3,512.8,220.7,512.1,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S509.2,224.3,508.5,224.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -30.0267 84.7679)",
    className: "st1",
    cx: 512.1,
    cy: 229.1,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,232,509.2,231.5,508.5,231.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -31.1745 84.8602)",
    className: "st1",
    cx: 512.1,
    cy: 236.3,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S509.2,238.7,508.5,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,242.8,512.8,242.3,512.1,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,246.4,509.2,245.9,508.5,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,250,512.8,249.5,512.1,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,253.6,509.2,253.1,508.5,253.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -34.6179 85.137)",
    className: "st1",
    cx: 512.1,
    cy: 257.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,260.8,509.2,260.2,508.5,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,264.4,512.8,263.8,512.1,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,268,509.2,267.4,508.5,267.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -36.9134 85.3216)",
    className: "st1",
    cx: 512.1,
    cy: 272.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,275.1,509.2,274.6,508.5,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.1,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C513.3,278.7,512.8,278.2,512.1,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,282.3,509.2,281.8,508.5,281.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -39.209 85.5062)",
    className: "st1",
    cx: 512.1,
    cy: 286.6,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C509.7,289.5,509.2,289,508.5,289z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1598 0.1598 0.9872 -40.3568 85.5984)",
    className: "st1",
    cx: 512.1,
    cy: 293.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 178.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 182.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,185.3,505.6,184.8,504.9,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,196.1,502,195.6,501.4,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,203.3,502,202.8,501.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,206.9,505.6,206.4,504.9,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,217.7,502,217.1,501.4,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,221.3,505.6,220.7,504.9,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,232,502,231.5,501.4,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,242.8,505.6,242.3,504.9,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,250,505.6,249.5,504.9,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,253.6,502,253.1,501.4,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,264.4,505.6,263.8,504.9,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,268,502,267.4,501.4,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,275.1,502,274.6,501.4,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.9,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C506.1,278.7,505.6,278.2,504.9,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.4,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.9,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C502.5,289.5,502,289,501.4,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.1,293.8c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.5,0.3,0.9,0.7,1.1l0.7,0.1 C505.7,294.8,506.1,294.4,506.1,293.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499,178.8c0,0,0-0.1,0-0.1l-1.8,1.1c0.2,0.1,0.4,0.2,0.7,0.2C498.4,180,499,179.5,499,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,185.3,498.4,184.8,497.8,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,188.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,188.9,494.8,188.4,494.2,188.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,196.1,494.8,195.6,494.2,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,203.3,494.8,202.8,494.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,206.9,498.4,206.4,497.8,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,210.5,494.8,210,494.2,210z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,217.7,494.8,217.1,494.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,221.3,498.4,220.7,497.8,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S494.8,224.3,494.2,224.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,232,494.8,231.5,494.2,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S494.8,238.7,494.2,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,242.8,498.4,242.3,497.8,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,246.4,494.8,245.9,494.2,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,250,498.4,249.5,497.8,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,253.6,494.8,253.1,494.2,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,260.8,494.8,260.2,494.2,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,264.4,498.4,263.8,497.8,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,268,494.8,267.4,494.2,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,275.1,494.8,274.6,494.2,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C499,278.7,498.4,278.2,497.8,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,282.3,494.8,281.8,494.2,281.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.8,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C495.4,289.5,494.8,289,494.2,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.8,292.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.1,0,0.3,0.1,0.4l2.1,0.2c0.1-0.2,0.2-0.4,0.2-0.6 C499,293.1,498.4,292.6,497.8,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,184.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,185.3,491.2,184.8,490.6,184.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 189.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.2,183.6c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.9-0.8-1.1l-1.6,1c0,0,0,0.1,0,0.1 C493,183.1,493.5,183.6,494.2,183.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 193.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,196.1,487.6,195.6,487,195.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,203.3,487.6,202.8,487,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,206.9,491.2,206.4,490.6,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,217.7,487.6,217.1,487,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,221.3,491.2,220.7,490.6,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,232,487.6,231.5,487,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,242.8,491.2,242.3,490.6,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,250,491.2,249.5,490.6,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,253.6,487.6,253.1,487,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,264.4,491.2,263.8,490.6,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,268,487.6,267.4,487,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,275.1,487.6,274.6,487,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C491.8,278.7,491.2,278.2,490.6,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 487,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.6,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C488.2,289.5,487.6,289,487,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,292.6c-0.6,0-1,0.4-1.2,1l2.3,0.2C491.8,293.1,491.2,292.6,490.6,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,192c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S484.1,192,483.4,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M481,189.6C481,189.6,481,189.6,481,189.6l-1.7,1c0.2,0.1,0.3,0.1,0.5,0.1C480.5,190.8,481,190.3,481,189.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,196.1,480.5,195.6,479.8,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,199.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,199.7,484.1,199.2,483.4,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,203.3,480.5,202.8,479.8,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,206.9,484.1,206.4,483.4,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.8,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,214.1,484.1,213.5,483.4,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,217.7,480.5,217.1,479.8,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,221.3,484.1,220.7,483.4,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.8,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,228.4,484.1,227.9,483.4,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,232,480.5,231.5,479.8,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,235.6,484.1,235.1,483.4,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.8,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,242.8,484.1,242.3,483.4,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.8,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,250,484.1,249.5,483.4,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,253.6,480.5,253.1,479.8,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,257.2,484.1,256.6,483.4,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.8,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,264.4,484.1,263.8,483.4,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,268,480.5,267.4,479.8,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,271.6,484.1,271,483.4,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,275.1,480.5,274.6,479.8,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,278.7,484.1,278.2,483.4,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 479.8,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C484.6,285.9,484.1,285.4,483.4,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.8,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C481,289.5,480.5,289,479.8,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,292.6c-0.3,0-0.6,0.1-0.9,0.4l1.8,0.2C484.1,292.8,483.8,292.6,483.4,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,194.4c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.3-0.8-0.6-1l-1.8,1.1C475,193.9,475.6,194.4,476.2,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,195.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,196.1,473.3,195.6,472.6,195.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -25.8937 78.646)",
    className: "st1",
    cx: 476.2,
    cy: 200.4,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,203.3,473.3,202.8,472.6,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C477.4,206.9,476.9,206.4,476.2,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,210c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,210.5,473.3,210,472.6,210z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -28.1889 78.8305)",
    className: "st1",
    cx: 476.2,
    cy: 214.7,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,217.7,473.3,217.1,472.6,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C477.4,221.3,476.9,220.7,476.2,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S473.3,224.3,472.6,224.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -30.484 79.015)",
    className: "st1",
    cx: 476.2,
    cy: 229.1,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,232,473.3,231.5,472.6,231.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -31.6316 79.1073)",
    className: "st1",
    cx: 476.2,
    cy: 236.3,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S473.3,238.7,472.6,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C477.4,242.8,476.9,242.3,476.2,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,246.4,473.3,245.9,472.6,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C477.4,250,476.9,249.5,476.2,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,253.6,473.3,253.1,472.6,253.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -35.0744 79.3841)",
    className: "st1",
    cx: 476.2,
    cy: 257.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,260.8,473.3,260.2,472.6,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C477.4,264.4,476.9,263.8,476.2,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,268,473.3,267.4,472.6,267.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -37.3696 79.5686)",
    className: "st1",
    cx: 476.2,
    cy: 272.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,275.1,473.3,274.6,472.6,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.2,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C477.4,278.7,476.9,278.2,476.2,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,282.3,473.3,281.8,472.6,281.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -39.6648 79.7531)",
    className: "st1",
    cx: 476.2,
    cy: 286.6,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.6,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C473.8,289.5,473.3,289,472.6,289z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 200.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,202.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,203.3,466.1,202.8,465.4,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C470.2,206.9,469.7,206.4,469,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465.4,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,217.7,466.1,217.1,465.4,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C470.2,221.3,469.7,220.7,469,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465.4,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,232,466.1,231.5,465.4,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465.4,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C470.2,242.8,469.7,242.3,469,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465.4,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C470.2,250,469.7,249.5,469,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,253.6,466.1,253.1,465.4,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465.4,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C470.2,264.4,469.7,263.8,469,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,268,466.1,267.4,465.4,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,275.1,466.1,274.6,465.4,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C470.2,278.7,469.7,278.2,469,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465.4,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465.4,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C466.6,289.5,466.1,289,465.4,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463,200.5l-1.6,1c0.1,0,0.3,0.1,0.4,0.1C462.4,201.6,462.9,201.1,463,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,206.9,462.5,206.4,461.8,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 458.2,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,214.1,462.5,213.5,461.8,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C459.4,217.7,458.9,217.1,458.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,221.3,462.5,220.7,461.8,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 458.2,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,228.4,462.5,227.9,461.8,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C459.4,232,458.9,231.5,458.2,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,235.6,462.5,235.1,461.8,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 458.2,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,242.8,462.5,242.3,461.8,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 458.2,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,250,462.5,249.5,461.8,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C459.4,253.6,458.9,253.1,458.2,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,257.2,462.5,256.6,461.8,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 458.2,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,264.4,462.5,263.8,461.8,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C459.4,268,458.9,267.4,458.2,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,271.6,462.5,271,461.8,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C459.4,275.1,458.9,274.6,458.2,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,278.7,462.5,278.2,461.8,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 458.2,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C463,285.9,462.5,285.4,461.8,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.2,289c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.4,0.1,0.5l2,0.2c0.1-0.2,0.3-0.4,0.3-0.7 C459.4,289.5,458.9,289,458.2,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,206.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C455.9,206.9,455.3,206.4,454.7,206.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 211.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.1,204.1c0.1,0.6,0.6,1,1.2,1c0.7,0,1.2-0.5,1.2-1.2c0-0.4-0.2-0.7-0.5-1L457.1,204.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 454.7,
    cy: 214.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.1,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C452.3,217.7,451.7,217.1,451.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C455.9,221.3,455.3,220.7,454.7,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 454.7,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.1,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C452.3,232,451.7,231.5,451.1,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 454.7,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C455.9,242.8,455.3,242.3,454.7,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C455.9,250,455.3,249.5,454.7,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.1,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C452.3,253.6,451.7,253.1,451.1,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 454.7,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C455.9,264.4,455.3,263.8,454.7,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.1,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C452.3,268,451.7,267.4,451.1,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 454.7,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.1,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C452.3,275.1,451.7,274.6,451.1,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C455.9,278.7,455.3,278.2,454.7,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 451.1,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 454.7,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.1,289c-0.6,0-1.1,0.5-1.2,1.1l2.4,0.2c0,0,0-0.1,0-0.1C452.3,289.5,451.7,289,451.1,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,213.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,214.1,448.1,213.5,447.5,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445,211.5l-1.4,0.8c0.1,0,0.1,0,0.2,0C444.4,212.3,444.9,212,445,211.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C445.1,217.7,444.5,217.1,443.9,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,221.3,448.1,220.7,447.5,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.9,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,228.4,448.1,227.9,447.5,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C445.1,232,444.5,231.5,443.9,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,235.6,448.1,235.1,447.5,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.9,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,242.8,448.1,242.3,447.5,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.9,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,250,448.1,249.5,447.5,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C445.1,253.6,444.5,253.1,443.9,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,257.2,448.1,256.6,447.5,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.9,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,264.4,448.1,263.8,447.5,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C445.1,268,444.5,267.4,443.9,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,271.6,448.1,271,447.5,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C445.1,275.1,444.5,274.6,443.9,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,278.7,448.1,278.2,447.5,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 443.9,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C448.7,285.9,448.1,285.4,447.5,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.9,289c-0.4,0-0.7,0.2-0.9,0.5l2,0.2C444.7,289.2,444.3,289,443.9,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,215.9c0.7,0,1.2-0.5,1.2-1.2c0-0.4-0.2-0.7-0.4-0.9l-1.9,1.2C439.3,215.6,439.7,215.9,440.3,215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,217.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,217.7,437.4,217.1,436.7,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C441.5,221.3,440.9,220.7,440.3,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,224.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S437.4,224.3,436.7,224.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -30.9404 73.2623)",
    className: "st1",
    cx: 440.3,
    cy: 229.1,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,232,437.4,231.5,436.7,231.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -32.0878 73.3545)",
    className: "st1",
    cx: 440.3,
    cy: 236.3,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S437.4,238.7,436.7,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C441.5,242.8,440.9,242.3,440.3,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,246.4,437.4,245.9,436.7,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C441.5,250,440.9,249.5,440.3,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,253.6,437.4,253.1,436.7,253.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -35.5299 73.6312)",
    className: "st1",
    cx: 440.3,
    cy: 257.8,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,260.8,437.4,260.2,436.7,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C441.5,264.4,440.9,263.8,440.3,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,268,437.4,267.4,436.7,267.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -37.8246 73.8156)",
    className: "st1",
    cx: 440.3,
    cy: 272.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,275.1,437.4,274.6,436.7,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C441.5,278.7,440.9,278.2,440.3,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.7,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C437.9,282.3,437.4,281.8,436.7,281.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9872 -0.1597 0.1597 0.9872 -40.1194 74.0001)",
    className: "st1",
    cx: 440.3,
    cy: 286.6,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,220.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C434.3,221.3,433.8,220.7,433.1,220.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.5,
    cy: 225.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 433.1,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.5,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C430.7,232,430.2,231.5,429.5,231.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 433.1,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.5,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C434.3,242.8,433.8,242.3,433.1,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.5,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C434.3,250,433.8,249.5,433.1,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.5,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C430.7,253.6,430.2,253.1,429.5,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 433.1,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.5,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C434.3,264.4,433.8,263.8,433.1,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.5,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C430.7,268,430.2,267.4,429.5,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 433.1,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.5,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C430.7,275.1,430.2,274.6,429.5,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.1,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C434.3,278.7,433.8,278.2,433.1,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 429.5,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 433.1,
    cy: 286.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427,222.4l-1.1,0.7c0,0,0,0,0,0C426.4,223.1,426.8,222.8,427,222.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,227.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,228.4,426.6,227.9,425.9,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C423.5,232,423,231.5,422.3,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,235.6,426.6,235.1,425.9,235.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 422.3,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,242.8,426.6,242.3,425.9,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 422.3,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,250,426.6,249.5,425.9,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C423.5,253.6,423,253.1,422.3,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,257.2,426.6,256.6,425.9,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 422.3,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,264.4,426.6,263.8,425.9,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C423.5,268,423,267.4,422.3,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,271.6,426.6,271,425.9,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C423.5,275.1,423,274.6,422.3,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,278.7,426.6,278.2,425.9,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 422.3,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C427.1,285.9,426.6,285.4,425.9,285.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 418.7,
    cy: 229.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,231.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,232,415.8,231.5,415.1,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,226.7c0.7,0,1.2-0.5,1.2-1.2c0-0.3-0.1-0.6-0.3-0.8l-2,1.2C421.4,226.4,421.8,226.7,422.3,226.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 418.7,
    cy: 236.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,238.7c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2S415.8,238.7,415.1,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C419.9,242.8,419.4,242.3,418.7,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,245.9c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,246.4,415.8,245.9,415.1,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C419.9,250,419.4,249.5,418.7,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,253.6,415.8,253.1,415.1,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 418.7,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,260.8,415.8,260.2,415.1,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C419.9,264.4,419.4,263.8,418.7,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,268,415.8,267.4,415.1,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 418.7,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,275.1,415.8,274.6,415.1,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C419.9,278.7,419.4,278.2,418.7,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.1,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C416.3,282.3,415.8,281.8,415.1,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.7,285.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.5,0.2,0.6l1.9,0.2c0.2-0.2,0.3-0.5,0.3-0.8 C419.9,285.9,419.4,285.4,418.7,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,235.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,235.6,412.2,235.1,411.6,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.9,233.5l-0.6,0.4C408.5,233.8,408.7,233.7,408.9,233.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 408,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,242.8,412.2,242.3,411.6,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 408,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,250,412.2,249.5,411.6,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C409.2,253.6,408.6,253.1,408,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,257.2,412.2,256.6,411.6,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 408,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,264.4,412.2,263.8,411.6,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C409.2,268,408.6,267.4,408,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,271.6,412.2,271,411.6,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C409.2,275.1,408.6,274.6,408,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C412.8,278.7,412.2,278.2,411.6,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 408,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.6,285.4c-0.7,0-1.2,0.5-1.2,1.2l2.4,0.2c0-0.1,0-0.1,0-0.2C412.8,285.9,412.2,285.4,411.6,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,237.5c0.7,0,1.2-0.5,1.2-1.2c0-0.3-0.1-0.5-0.2-0.7l-2,1.2C403.5,237.2,403.9,237.5,404.4,237.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 400.8,
    cy: 239.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,242.8,405,242.3,404.4,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 400.8,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,250,405,249.5,404.4,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C402,253.6,401.4,253.1,400.8,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,257.2,405,256.6,404.4,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 400.8,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,264.4,405,263.8,404.4,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C402,268,401.4,267.4,400.8,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,271.6,405,271,404.4,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.8,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C402,275.1,401.4,274.6,400.8,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C405.6,278.7,405,278.2,404.4,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 400.8,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.4,285.4c-0.4,0-0.8,0.2-1,0.6l2.1,0.2C405.3,285.7,404.9,285.4,404.4,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,242.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,242.8,397.8,242.3,397.2,242.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 247.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,250,397.8,249.5,397.2,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.6,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C394.8,253.6,394.3,253.1,393.6,253.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 397.2,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,264.4,397.8,263.8,397.2,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.6,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C394.8,268,394.3,267.4,393.6,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 397.2,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.6,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C394.8,275.1,394.3,274.6,393.6,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C398.4,278.7,397.8,278.2,397.2,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 393.6,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.1,285.4l0.3,0C397.3,285.4,397.3,285.4,397.1,285.4C397.2,285.4,397.1,285.4,397.1,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,249.5c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,250,390.7,249.5,390,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C387.6,253.6,387.1,253.1,386.4,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,257.2,390.7,256.6,390,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 386.4,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,264.4,390.7,263.8,390,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C387.6,268,387.1,267.4,386.4,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,271.6,390.7,271,390,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C387.6,275.1,387.1,274.6,386.4,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C391.2,278.7,390.7,278.2,390,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 386.4,
    cy: 283,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.6,250.7c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.1,0-0.3,0-0.4,0.1 l-0.4,0.2C381.8,250,381.6,250.3,381.6,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,253.1c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,253.6,379.9,253.1,379.2,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.4,248.3c0.7,0,1.2-0.5,1.2-1.2c0-0.2-0.1-0.4-0.2-0.6l-2,1.2C385.6,248,386,248.3,386.4,248.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 382.8,
    cy: 257.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,260.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,260.8,379.9,260.2,379.2,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C384,264.4,383.5,263.8,382.8,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,268,379.9,267.4,379.2,267.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 382.8,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.2,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C380.4,275.1,379.9,274.6,379.2,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C384,278.7,383.5,278.2,382.8,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.4,283c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.5,0.3,0.8l1.7,0.1 C380.3,283.7,380.4,283.4,380.4,283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,256.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,257.2,376.3,256.6,375.6,256.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 372,
    cy: 261.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,264.4,376.3,263.8,375.6,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C373.2,268,372.7,267.4,372,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C376.8,271.6,376.3,271,375.6,271z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C373.2,275.1,372.7,274.6,372,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 C376.8,278.7,376.3,278.2,375.6,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372,281.8c-0.7,0-1.2,0.5-1.2,1.2c0,0,0,0.1,0,0.1l2.3,0.2c0-0.1,0.1-0.2,0.1-0.3 C373.2,282.3,372.7,281.8,372,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,259c0.7,0,1.2-0.5,1.2-1.2c0-0.2,0-0.3-0.1-0.5l-2,1.2C367.8,258.9,368.1,259,368.5,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,264.4,369.1,263.8,368.5,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C366.1,268,365.5,267.4,364.9,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,271c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,271.6,369.1,271,368.5,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C366.1,275.1,365.5,274.6,364.9,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C369.6,278.7,369.1,278.2,368.5,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,281.8c-0.5,0-0.9,0.3-1.1,0.7l2.2,0.2C365.8,282.2,365.4,281.8,364.9,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,263.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C362.5,264.4,361.9,263.8,361.3,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,267.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,268,358.3,267.4,357.7,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,262.6c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c0,0,0,0-0.1,0l-1,0.6c-0.1,0.2-0.2,0.4-0.2,0.6 C363.7,262.1,364.2,262.6,364.9,262.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 361.3,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C358.9,275.1,358.3,274.6,357.7,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C362.5,278.7,361.9,278.2,361.3,278.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 354.1,
    cy: 272.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.7,268.6c0-0.1,0-0.2-0.1-0.3l-2,1.2c0.2,0.2,0.5,0.3,0.8,0.3C351.2,269.8,351.7,269.3,351.7,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.5,274.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C351.7,275.1,351.2,274.6,350.5,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C355.3,278.7,354.7,278.2,354.1,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.2,281.9l1,0.1c-0.2-0.1-0.4-0.2-0.6-0.2C357.5,281.8,357.4,281.8,357.2,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,273.4c0.7,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.1-1-1.2l-1.3,0.8c0,0.1-0.1,0.3-0.1,0.4 C345.7,272.9,346.2,273.4,346.9,273.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.9,278.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C348.1,278.7,347.6,278.2,346.9,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.1,275.8c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2 C342.6,274.6,342.1,275.1,342.1,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.9,279.4c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.3,0.2,0.7,0.4,0.9l1.4,0.1 C340.7,280.2,340.9,279.8,340.9,279.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.7,279.2l-0.9,0.5l0.9,0.1c0-0.1,0.1-0.3,0.1-0.4C333.7,279.3,333.7,279.3,333.7,279.2z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "3.3,326.4 79.4,326.2 155.4,326.1 307.4,325.9 459.4,326.1 535.4,326.2 611.4,326.4 535.4,326.7  459.4,326.8 307.4,326.9 155.4,326.8 79.4,326.7  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 309.4,
    cy: 369.6,
    rx: 286.7,
    ry: 31.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "510.7,376.3 206,376.3 250.1,126.5 554.8,126.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "354.3,100.6 254.6,100.6 250.1,126.5 356.8,126.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "510.7,376.3 206,376.3 250.1,126.5 554.8,126.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.3,100.6 254.6,100.6 250.1,126.5 356.8,126.5  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "509.7,376.3 204.3,376.3 161,135.5 466.3,135.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 161,
    cy: 135.5,
    r: 33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 153.2,
    y1: 127.8,
    x2: 168.8,
    y2: 143.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 153.2,
    y1: 143.3,
    x2: 168.8,
    y2: 127.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M335.8,284.8l-0.7-1.3c-0.1-0.1-6.6-12.2-19.8-12.2c-12,0-15,11.4-15.1,11.9l-0.4,1.5l-2.9-0.7l0.3-1.5 c0-0.1,3.6-14.2,18-14.2c15,0,22.2,13.3,22.5,13.8l0.7,1.3L335.8,284.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 359.9,
    y1: 218.9,
    x2: 375.5,
    y2: 234.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 359.9,
    y1: 234.4,
    x2: 375.5,
    y2: 218.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 259.6,
    y1: 218.9,
    x2: 275.1,
    y2: 234.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 259.6,
    y1: 234.4,
    x2: 275.1,
    y2: 218.9
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Fly"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M490,268.6c0.7-0.1,1.3-0.3,1.9-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M495.8,267c15.3-5.2,28.1-17.2,29.3-31.3c2.7-31-35.1-48.1-31.2-83.9c3.7-34.2,39.6-36.6,53.9-31.9 c15.9,5.2,10.4,20.5-3.9,18.5c-24.9-3.4-40.6-30.5-28.7-61.2c8.8-23,30.9-31.6,39.8-34.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M556.9,42.4c1.2-0.3,1.9-0.5,1.9-0.5"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M574.7,36.4c-2.6-7.9-19.6-5.1-16.3,5.3C561.7,52,577.3,44.3,574.7,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.1,33.2c0.1-3.5,4.9-6.1,11.8-4.9c6.8,1.2,13.2,5.8,13.2,5.8s-6.7,4.1-13.6,4.9 C553.6,39.7,549,36.7,549.1,33.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M574.1,34.2c-3.5,0-7.1-0.1-10.6-0.2c-3.5-0.2-7.1-0.3-10.6-0.6c3.5,0,7.1,0.1,10.6,0.2 C567.1,33.7,570.6,33.9,574.1,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M556,30.2c1,0.5,2,1,2.9,1.6c0.9,0.6,1.9,1.2,2.7,1.9c-1-0.5-2-1-2.9-1.6C557.8,31.5,556.8,30.9,556,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M565.2,33.8c-0.9,0.8-1.9,1.4-2.8,2c-1,0.6-2,1.2-3,1.7c0.9-0.8,1.9-1.4,2.8-2 C563.2,35,564.2,34.3,565.2,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M566.3,31.9c0.5,0.2,1,0.6,1.4,0.9c0.4,0.4,0.8,0.7,1.2,1.2c-0.5-0.2-1-0.6-1.4-0.9 C567,32.7,566.6,32.4,566.3,31.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.6,53.8c2.1,2.7,7.6,2.1,12.4-2.9c4.8-5,7.3-12.5,7.3-12.5s-7.9,0.6-13.9,4 C555.4,45.9,553.5,51.1,555.6,53.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M575.4,38.4c-2.9,2.1-5.7,4.2-8.5,6.4c-2.8,2.2-5.6,4.4-8.3,6.7c2.9-2,5.7-4.2,8.5-6.4 C569.9,42.9,572.7,40.7,575.4,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M563,52.3c0.6-1,1-2,1.4-3c0.4-1,0.8-2.1,1.1-3.2c-0.6,1-1,2-1.4,3C563.6,50.2,563.2,51.2,563,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M568.3,43.9c-1.2-0.1-2.3,0-3.5,0c-1.2,0.1-2.3,0.2-3.5,0.4c1.2,0.1,2.3,0,3.5,0 C566,44.2,567.2,44.1,568.3,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M570.3,44.9c0.3-0.5,0.5-1,0.6-1.6c0.1-0.5,0.3-1.1,0.3-1.7c-0.3,0.5-0.5,1-0.6,1.6 C570.4,43.8,570.3,44.3,570.3,44.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M574.7,36.4c-1.6,0.5-3.3-0.4-3.8-1.9c-0.5-1.6,0.4-3.3,1.9-3.8c1.6-0.5,3.3,0.4,3.8,1.9 C577.1,34.2,576.3,35.9,574.7,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M576.5,42.1c-1.6,0.5-3.3-0.4-3.8-1.9c-0.5-1.6,0.4-3.3,1.9-3.8c1.6-0.5,3.3,0.4,3.8,1.9 C579,39.9,578.1,41.6,576.5,42.1z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/noDataFound.d4243e3201cf79465f74d425123fad4b.svg";
export { ForwardRef as ReactComponent };